<template>
    <div>
            <!-- 탕전신청  -->
            <div class="title jc" v-show="currentMenu === 0">
                <h2>탕전신청 </h2>
            </div>
            <div class="title pb20" v-show="currentMenu === 1">
                <h2>복용법</h2>
            </div>    
            <!-- <div class="title" v-show="currentMenu === 2">
                <h2>배송정보</h2>
            </div>     -->
            <div class="title" v-show="currentMenu === 2">
                <h2>탕전신청 확인</h2>
            </div>                              
            <article class="view">
                <UserStep :userStep="userStep" />
                <!-- 탕제 신청  -->
                <div class="tab_contents" v-show="currentMenu === 0" >
  
                    <div class="lay_left lay_left--wide" ref="leftRef">
                        <div class="table_list">
                            <table class="list no_view">
                                <thead>
                                    <tr>
                                        <th>처방분류</th>
                                        <th>급여구분</th>
                                        <th>처방일자</th>
                                        <th>처방기관</th>
                                        <th>처방의</th>
                                        <th>조제의뢰처</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span>{{application.prescribe_type_nm}}</span></td>
                                        <td><span>비급여</span></td>
                                        <td><span>{{getCurrentDate()}}</span></td>
                                        <td><span>{{application.clinic_nm}}</span></td>
                                        <td><span>{{application.doctor_nm}}</span></td>
                                        <td><span>코끼리 원외탕전</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 환자 정보 -->
                        <div class="table_list">
                            <h3 class="tb_title">환자</h3>
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>환자 정보</span></th>
                                        <td v-if="!isUserSelect">
                                            <button
                                                class="btn btn_md btn_darkbrown"
                                                @click="fn_click_search_petient()"
                                            >
                                                검색
                                            </button>
                                        </td>
                                        <td v-else>
                                            <div class="reset">
                                                    <!-- <button class="link"
                                                    @click="isShow.patient = !isShow.patient"> -->
                                                     <button class="link">
                                                    <p>{{patientViewInfo}}</p>
                                                </button>
                                                <button
                                                    class="btn btn_md btn_darkbrown btn_outline"
                                                    @click="resetDataPatient"
                                                >
                                                    환자초기화
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>처방 메모</th>
                                        <td><textarea v-model="application.prescribe_note" class="form_control"></textarea></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 처방전 -->
                        <div class="table_list">
                            <h3 class="tb_title">처방전</h3>
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span class="emp">처방명</span></th>
                                        <td>
                                            <div class="form_inline w100">
                                                <input type="text" class="form_control" v-model="application.prescribe_nm" placeholder="입력하세요."  @keyup.enter="fn_search_prescribe" :readonly="!!application.secret_prescription_seq">
                                                <button
                                                    class="btn btn_md btn_darkbrown"
                                                    @click="fn_search_prescribe"
                                                >
                                                    검색
                                                </button>
                                                <button
                                                    class="btn btn_md btn_darkbrown btn_outline"
                                                    style="white-space: nowrap;"
                                                    @click="fn_search_init"
                                                >
                                                    처방초기화
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>출전명</span></th>
                                        <td><input type="text" class="form_control" v-model="application.prescribe_source" placeholder="입력하세요." :readonly="!!application.secret_prescription_seq"></td>
                                    </tr>
                                    <tr>
                                        <th><span>약재 검색 </span></th>
                                        <td>
                                            <div class="form_inline w100">
                                                <input
                                                    type="text"
                                                    class="form_control"
                                                    placeholder="입력하세요."
                                                    ref="medSearchInfo"
                                                    v-model="searchMedicineWord.med_hrb_nm"
                                                    @keyup.enter="fn_click_medicine_search"
                                                >
                                                <button
                                                    class="btn btn_md btn_darkbrown"
                                                    @click="fn_click_medicine_search"
                                                >
                                                    검색
                                                </button>                                                                                             
                                                <transition name="slide-fade">
                                                    <div class="auto_box" v-show="medicinesearchBoxShow">
                                                        <div class="tb_title">
                                                            <h3>
                                                                <strong>'{{ searchMedicineWord.med_hrb_nm }}'</strong> 의 검색결과 ({{medicineWordlist.length || 0}}건)
                                                            </h3>
                                                            <button class="button-right close" @click="medicinesearchBoxShow = false">
                                                                <b-icon icon="X" font-scale="2"></b-icon>
                                                            </button>                                                               
                                                        </div>
                                                        <table class="list no_view">
                                                            <colgroup>
                                                                <col width="100">
                                                                <col width="300">
                                                                <col width="300">
                                                                <col width="300">
                                                                <col width="300">
                                                            </colgroup>
                                                            <tbody>
                                                                <tr v-for="(item, idx) in medicineWordlist" :key="idx" :class="{nostack : item.med_sale_prc === 0}">
                                                                    <td @click="fn_add_medicine(item)"><span class="bdge best_icon" v-if="item.rank == 0">추천</span></td>
                                                                    <td @click="fn_add_medicine(item)">{{ item.med_hrb_nm }}</td>
                                                                    <td @click="fn_add_medicine(item)">{{ item.org_plce_nm }}</td>
                                                                    <td @click="fn_add_medicine(item)">{{ item.med_sale_prc }}원</td>
                                                                    <td><button class="bdge bd_brown" @click="fn_medicine_search_detail(item)">정보</button></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </transition>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 처방 약재 -->
                        <div class="table_list">
                            <div class="tb_title_row">
                                <h3 class="tb_title">처방 약재</h3>
                                <span class="scret_dictionary_badge" v-if="application.secret_prescription_seq">비방사전 적용</span>
                                <span class="scret_dictionary_desc" v-if="application.secret_prescription_seq">※ 비방사전구성 약재는 재고가 없는 약재 외에는 삭제할 수 없습니다. 단, 약재추가는 가능</span>
                            </div>
                            <table class="list no_view mb10" ref="meficineTable">
                                <colgroup>
                                    <col width="300">
                                    <col width="300">
                                    <col width="300">
                                    <col width="300">
                                    <col width="300">
                                    <col width="300">
                                    <col width="300">
                                </colgroup>
                                <thead>                
                                    <tr>
                                        <th>No</th>
                                        <th>약재명</th>
                                        <th>원산지</th>
                                        <th>첩량</th>
                                        <th>약재량</th>
                                        <th>약재비</th>
                                        <th>처리</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="application.prescribe_medicine.length == 0">
                                        <td colspan="6"><span>입력된 약재가 없습니다.</span></td>
                                    </tr>
                                    <tr v-for="(item, index) in application.prescribe_medicine" :key="index" :class="{duplication : item.duplication === true, nostack : item.med_sale_prc === 0}">
                                        <td><span>{{ index+1 }}</span></td>
                                        <td><span>{{ item.med_hrb_nm }}</span></td>
                                        <td><span>{{ item.org_plce_nm }}</span></td>
                                        <td><div class="form_inline"><input type="text" v-model="item.chupCnt" placeholder="입력하세요" class="form_control" @change="fn_change_medicineInfo(index)" @keyup.enter="fn_change_medicineInfo(index)" :readonly="item.med_sale_prc === 0"></div></td>
                                        <td><span>{{ item.medicineQy }} g</span></td>
                                        <td><span>{{ item.totalPrice }} 원</span></td>
                                        <td><button class="bdge bd_red" @click="fn_medicine_delete(index)">삭제</button></td>                                        
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td><span>{{ application.sum_chup_qy }} g</span></td>
                                        <td><span>{{ application.total_medicin_qy }} g</span></td>
                                        <td><span>{{ application.total_price }} 원</span></td>
                                        <td></td>                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="ar pb20">
                            <button
                                class="btn btn_md btn_darkbrown btn_outline mr10"
                                @click="fn_search_init"
                            >
                                처방초기화
                            </button> 
                            <button class="btn btn_md btn_darkbrown" @click="fn_reg_my_application">내 처방 등록</button>
                        </div>
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>                                
                                    <tr>
                                        <th><span>첩수</span></th>
                                        <td>
                                            <div class="form_select">
                                                <!-- <span>{{application.sum_chup_qy}} x</span> -->
                                                <b-form-select v-model="application.chup_cnt" class="w100" @change="fn_change_chup_cnt">
                                                    <b-form-select-option v-for="chupCnt in 100" :key="chupCnt" :value=chupCnt >{{chupCnt}}첩</b-form-select-option>                                                   
                                                </b-form-select>
                                            </div>
                                        </td>
                                        <th><span>팩수</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.packCnt" class="w100" @change="fn_chg_packCnt">
                                                    <b-form-select-option :value="null">선택</b-form-select-option>                                                
                                                    <b-form-select-option v-for="(value,index) in packlist" :key="index" :value="value">{{value}}팩</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>팩용량</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.packQy" class="w100">                                                    
                                                    <b-form-select-option :value="50">50ml</b-form-select-option>
                                                    <b-form-select-option :value="60">60ml &#40;유아&#41;</b-form-select-option>
                                                    <b-form-select-option :value="70">70ml</b-form-select-option>
                                                    <b-form-select-option :value="80">80ml &#40;소아&#41;</b-form-select-option>
                                                    <b-form-select-option :value="90">90ml</b-form-select-option>
                                                    <b-form-select-option :value="100">100ml &#40;표준&#41;</b-form-select-option>
                                                    <b-form-select-option :value="110">110ml</b-form-select-option>
                                                    <b-form-select-option :value="120">120ml</b-form-select-option>
                                                    <b-form-select-option :value="130">130ml</b-form-select-option>
                                                    <b-form-select-option :value="140">140ml</b-form-select-option>
                                                    <b-form-select-option :value="150">150ml</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                        <th><span>압력여부</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.pressureYn" class="w100">                                                    
                                                    <b-form-select-option value="N">무압력</b-form-select-option>
                                                    <b-form-select-option value="Y">압력</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>감미제</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.sweetener" class="w100" @change="fn_etc_count">                                                    
                                                    <b-form-select-option value="0">감미제 없음</b-form-select-option>
                                                    <b-form-select-option value="1">단맛1단계</b-form-select-option>
                                                    <b-form-select-option value="2">단맛2단계</b-form-select-option>
                                                    <b-form-select-option value="3">단맛3단계</b-form-select-option>
                                                    <b-form-select-option value="4">단맛4단계</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                        <th><span>향기</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.sweet_flavor" class="w100" @change="fn_etc_count">                                                    
                                                    <b-form-select-option value="">향기 없음</b-form-select-option>
                                                    <b-form-select-option value="CA1">약한카라멜향(0.5%)</b-form-select-option>
                                                    <b-form-select-option value="CA2">약한카라멜향(1%)</b-form-select-option>
                                                    <b-form-select-option value="SB1">약한딸기향(0.5%)</b-form-select-option>
                                                    <b-form-select-option value="SB2">약한딸기향(1%)</b-form-select-option>
                                                    <b-form-select-option value="CH1">약한초코향(0.5%)</b-form-select-option>
                                                    <b-form-select-option value="CH2">약한초코향(1%)</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <th><span>녹용 앰플</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.ny_ampul" class="w100" @change="fn_etc_count">                                                    
                                                    <b-form-select-option value="0">사용안함</b-form-select-option>
                                                    <b-form-select-option value="30">30ml</b-form-select-option>
                                                    <b-form-select-option value="60">60ml</b-form-select-option>
                                                    <b-form-select-option value="90">90ml</b-form-select-option>
                                                    <b-form-select-option value="120">120ml</b-form-select-option>
                                                    <b-form-select-option value="150">150ml</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                        <th><span>자하거&#40;앰플&#41;</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.jhg" class="w100" @change="fn_etc_count">                                                    
                                                    <b-form-select-option value="0">사용안함</b-form-select-option>
                                                    <b-form-select-option value="30">30ml</b-form-select-option>
                                                    <b-form-select-option value="60">60ml</b-form-select-option>
                                                    <b-form-select-option value="90">90ml</b-form-select-option>
                                                    <b-form-select-option value="120">120ml</b-form-select-option>
                                                    <b-form-select-option value="150">150ml</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr> -->
                                    
                                </tbody>
                            </table>
                        </div>
                        <div class="table_list">
                            <!-- 파우치 -->
                            <div class="wrapper-section">
                                <h3 class="tb_title">파우치</h3>
                                <div class="img_slide_wrap">
                                    <button v-if="pouchImgList.length > 3" class="slide-btn" @click="slidePage('pouch', -1)" :disabled="pouchOffset === 0">&#8249;</button>
                                    <div class="img_list">
                                        <div
                                            v-for="(item, index) in pouchImgList"
                                            :key="index"
                                            v-show="index >= pouchOffset && index < pouchOffset + 3"
                                            @click="fn_select_pouch_img(item, index)"
                                            @mouseenter="(evt) => viewBoxHandler(evt, item, 'pouch')"
                                            @mouseleave="viewPouch = {}"
                                            :class="{ on: selectPouchImgIdx === index }"
                                        >
                                            <img :src="'/file/getImgFile/' + item.wrapper_file_id" alt="">
                                            <p>{{ item.wrapper_nm }}</p>
                                            <p>개당 {{ fn_comma_won(item.wrapper_sale_prc) }} 원</p>
                                        </div>
                                        <div class="preview" v-if="viewPouch.wrapper_file_id" :style="`left: ${viewPositionX}px;`">
                                            <img :src="'/file/getImgFile/' + viewPouch.wrapper_file_id" alt="">
                                            <p>{{ viewPouch.wrapper_nm }}</p>
                                        </div>
                                    </div>
                                    <button v-if="pouchImgList.length > 3" class="slide-btn" @click="slidePage('pouch', 1)" :disabled="pouchOffset + 3 >= pouchImgList.length">&#8250;</button>
                                </div>
                            </div>
                            <!-- 포장 -->
                            <div class="wrapper-section">
                                <h3 class="tb_title">포장</h3>
                                <div class="img_slide_wrap">
                                    <button v-if="wrapperImgList.length > 3" class="slide-btn" @click="slidePage('wrapper', -1)" :disabled="wrapperOffset === 0">&#8249;</button>
                                    <div class="img_list">
                                        <div
                                            v-for="(item, index) in wrapperImgList"
                                            :key="index"
                                            v-show="index >= wrapperOffset && index < wrapperOffset + 3"
                                            @click="fn_select_wrapper_img(item, index)"
                                            @mouseenter="(evt) => viewBoxHandler(evt, item, 'wrapper')"
                                            @mouseleave="viewWrapper = {}"
                                            :class="{ on: selectWrapperImgIdx === index }"
                                        >
                                            <img :src="'/file/getImgFile/' + item.wrapper_file_id" alt="">
                                            <p>{{ item.wrapper_nm }}</p>
                                        </div>
                                        <div class="preview" v-if="viewWrapper.wrapper_file_id" :style="`left: ${viewPositionX}px;`">
                                            <img :src="'/file/getImgFile/' + viewWrapper.wrapper_file_id" alt="">
                                            <p>{{ viewWrapper.wrapper_nm }}</p>
                                        </div>
                                    </div>
                                    <button v-if="wrapperImgList.length > 3" class="slide-btn" @click="slidePage('wrapper', 1)" :disabled="wrapperOffset + 3 >= wrapperImgList.length">&#8250;</button>
                                </div>
                            </div>
                            <!-- 박스 -->
                            <div class="wrapper-section">
                                <h3 class="tb_title">박스</h3>
                                <div class="img_slide_wrap">
                                    <button v-if="boxImgList.length > 3" class="slide-btn" @click="slidePage('box', -1)" :disabled="boxOffset === 0">&#8249;</button>
                                    <div class="img_list">
                                        <div
                                            v-for="(item, index) in boxImgList"
                                            :key="index"
                                            v-show="index >= boxOffset && index < boxOffset + 3"
                                            @click="fn_select_box_img(item, index)"
                                            @mouseenter="(evt) => viewBoxHandler(evt, item, 'box')"
                                            @mouseleave="viewBox = {}"
                                            :class="{ on: selectBoxImgIdx === index }"
                                        >
                                            <img :src="'/file/getImgFile/' + item.wrapper_file_id" alt="">
                                            <p>{{ item.wrapper_nm }}</p>
                                            <p>개당 {{ fn_comma_won(item.wrapper_sale_prc) }} 원</p>
                                        </div>
                                        <div class="preview" v-if="viewBox.wrapper_file_id" :style="`left: ${viewPositionX}px;`">
                                            <img :src="'/file/getImgFile/' + viewBox.wrapper_file_id" alt="">
                                            <p>{{ viewBox.wrapper_nm }}</p>
                                        </div>
                                    </div>
                                    <button v-if="boxImgList.length > 3" class="slide-btn" @click="slidePage('box', 1)" :disabled="boxOffset + 3 >= boxImgList.length">&#8250;</button>
                                </div>
                            </div>
                        </div>
                        <!-- 마킹 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>마킹</span></th>
                                        <td>
                                            <div class="form_select">
                                                <b-form-select v-model="application.mark_yn" class="w100">
                                                    <b-form-select-option value="Y">환자이름,조제날짜</b-form-select-option>
                                                    <b-form-select-option value="N">마킹없음</b-form-select-option>
                                                </b-form-select>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 포장요구사항 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>포장요구사항</span></th>
                                        <td colspan="3">
                                            <textarea name="" id="" class="form_control" placeholder="입력해주세요." v-model="application.wrapperReq" ></textarea>                                            
                                        </td>
                                    </tr>                                    
                                </tbody>
                            </table>
                        </div>
                        <!-- 조제 지시 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>조제지시</span></th>
                                        <td colspan="3">
                                            <textarea name="" id="" class="form_control" placeholder="입력해주세요." v-model="application.instructions"></textarea>
                                        </td>                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="lay_right fix">
                        <div>
                            <div class="search" v-show="isShow.patient">
                                <div class="table_list">
                                    <div class="tabs">
                                        <button
                                            class="tb_title"
                                            v-for="(tab, idx) in tabMenuNames.patient" :key="idx"
                                            @click="fn_click_tab(idx)"
                                            :class="{ on:tabIndices.patient === idx }"
                                        >
                                            {{ tab }}
                                        </button>
                                        <button class="btn btn_md btn_brown ab-button" v-b-modal.petientWriteModal>
                                            <b-icon icon="person-plus-fill" class="mr10"></b-icon>
                                            등록
                                        </button>
                                    </div>
                                    <!-- 탕전신청  - #환자정보 -->
                                    <table class="write" v-show="tabIndices.patient === 0">
                                        <colgroup>
                                            <col width="100">
                                        </colgroup>
                                        <tbody v-if="selectPetientInfo.patient_chart_no ==  null">
                                            <tr>
                                                <td><span>환자가 선택되지 않았습니다.</span></td>                                            
                                            </tr>
                                        </tbody>
                                        <tbody v-else>
                                            <tr>
                                                <th><span>차트 번호</span></th>
                                                <td><span>{{ selectPetientInfo.patient_chart_no }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>이름</span></th>
                                                <td><span>{{ selectPetientInfo.patient_nm }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>성별</span></th>
                                                <td><span>{{ selectPetientInfo.patient_gender_nm }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>나이</span></th>
                                                <td><span>{{ selectPetientInfo.patient_age }}세</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>최근처방일</span></th>
                                                <td><span>{{ selectPetientInfo.last_prescribe_dt }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>연락처</span></th>
                                                <td><span>{{ formatPhoneNumber(selectPetientInfo.patient_tel_num) }}</span></td>
                                            </tr>
                                            <tr>
                                                <th><span>주소</span></th>
                                                <td><span>{{ selectPetientInfo.patient_addr }} {{selectPetientInfo.patient_addr_dtl}}</span></td>
                                            </tr>
                                            <!-- <tr>
                                                <th><span>환자 메모</span></th>
                                                <td><span>{{ selectPetientInfo.patient_note }}</span></td>
                                            </tr> -->
                                        </tbody>
                                    </table>
                                    <!-- 탕전신청  - #처방내역 -->
                                    <div v-show="tabIndices.patient === 1">
                                        <table class="list">
                                            <thead>
                                                <tr>
                                                    <th v-for="(th, index) in rightPatientInfoHead" :key="index">{{th.head}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="patientPrescribeList.length == 0">
                                                    <td colspan="5"><span>데이터가 없습니다.</span></td>
                                                </tr>
                                                <tr
                                                    v-for="(item, index) in patientPrescribeList" :key="index"
                                                    :class="{ active:gridSelect.patientPrescribe === index }"
                                                >
                                                    <td @click="fn_show_patient_prescribe_detail(item,index)"><span>{{ item.prescribe_dt }}</span></td>
                                                    <td @click="fn_show_patient_prescribe_detail(item,index)"><span>{{ item.prescribe_type_nm }}</span></td>
                                                    <td @click="fn_show_patient_prescribe_detail(item,index)"><span>{{ item.prescribe_nm }}</span></td>
                                                    <td @click="fn_show_patient_prescribe_detail(item,index)"><span>{{ item.doctor_nm }}</span></td>
                                                    <td><button class="bdge bd_brown" @click="fn_show_patient_prescribe_detail(item,index)">반영</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <prescribePagination :pageInfo=searchPatientPrescribe.pageInfo @clickPage="fn_move_patient_prescribe" v-show="searchPatientPrescribe.patientPrescribeShow"/> 
                                    </div>
                                    <div v-show="tabIndices.patient === 2">
                                        <!-- 환자검색 - #환자검색  -->
                                        <div class="list">                                        
                                            <ul class="search_filter">
                                                <li>
                                                    <p>환자명</p>
                                                    <input type="text" ref="inputPatientNm" placeholder="환자명을(를) 입력하세요" class="form_control" v-model="searchPatient.searchPatientNm" @change="fn_patient_page_init" @keyup.enter="fn_search_patient(false)">
                                                    <button class="btn btn_md btn_outline" @click="fn_search_patient(false)" >검색</button>
                                                </li>
                                            </ul>
                                            <table class="list">
                                                <colgroup>
                                                    <col width="100">
                                                </colgroup>
                                                <thead>
                                                    <tr>
                                                        <th>차트</th>
                                                        <th>환자명</th>
                                                        <th>성별/나이</th>
                                                        <th>최근처방일</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="patientList.length == 0">
                                                        <td colspan="5"><span>데이터가 없습니다.</span></td>
                                                    </tr>
                                                <tr
                                                    v-for="(item, index) in patientList"
                                                    :key="index"
                                                    @click="fn_choose_patient(item)"
                                                >
                                                    <td><span>{{ item.patient_chart_no }}</span></td>
                                                    <td><span>{{ item.patient_nm }}</span></td>
                                                    <td><span>{{ item.patient_gender_nm }}/{{ item.patient_age }}</span></td>
                                                    <td><span>{{ item.last_prescribe_dt }}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <PetientPagination :pageInfo="searchPatient.pageInfo" @clickPage="fn_move_patientPage" v-show="searchPatient.PatientPageShow"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="search" v-show="isShow.medicine">
                                <div class="table_list">
                                    <div class="tabs">
                                        <button
                                            class="tb_title"
                                            v-for="(tab, idx) in tabMenuNames.medicine" :key="idx"
                                            @click="resetDataMedicne(idx), tabIndices.medicine = idx"
                                            :class="{ on:tabIndices.medicine === idx, blink: tab === '비방사전' && tabIndices.medicine !== idx }"
                                        >
                                            {{ tab }}
                                        </button>
                                    </div>
                                    <!-- 약재 - #약재검색 -->
                                    <div v-show="tabIndices.medicine === 0">
                                        <ul class="search_filter">
                                            <li>
                                                <p>약재 검색</p>
                                                <input type="text" placeholder="약재를 입력하세요" class="form_control" v-model="searchMedicine.med_hrb_nm" @keyup.enter="fn_search_medicine">
                                                <button class="btn btn_md btn_outline" @click="fn_search_medicine">검색</button>
                                            </li>
                                        </ul>
                                        <table class="list medicine_search_list">
                                            <colgroup>
                                                <col style="width:auto">
                                                <col style="width:20%">
                                                <col style="width:20%">
                                                <col style="width:90px">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>약재명</th>
                                                    <th>원산지</th>
                                                    <th>가격(g)</th>
                                                    <th>반영</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="medicinelist.length == 0">
                                                    <td colspan="5"><span>데이터가 없습니다.</span></td>
                                                </tr>
                                                <tr
                                                    v-for="(item, index) in medicinelist" :key="index"
                                                    :class="{ active:gridSelect.medicine === index, nostack : item.med_sale_prc === 0 }"
                                                >
                                                    <td @click="fn_show_medicine_detail(item,index)"><span>{{ item.med_hrb_nm }}</span></td>
                                                    <td @click="fn_show_medicine_detail(item,index)"><span>{{ item.org_plce_nm }}</span></td>
                                                    <td @click="fn_show_medicine_detail(item,index)"><span>{{ item.med_sale_prc }}</span></td>
                                                    <td><button class="bdge bd_brown" @click="fn_add_medicine(item),fn_grid_select_medicine(index)">반영</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <medicinePagination :pageInfo=searchMedicine.pageInfo @clickPage="fn_search_medicine" v-show="searchMedicine.medicinePageShow"/>
                                        
                                    </div>
                                    <!-- 개인 방제 - #개인방제검색  -->                                
                                    <div v-show="tabIndices.medicine === 1">
                                        <ul class="search_filter">
                                            <li>
                                                <p>개인방제검색</p>
                                                <input type="text" placeholder="개인방제를 입력하세요" v-model="searchMyPrescribe.prescribe_nm" class="form_control" @change="fn_myPrescribe_page_init" @keyup.enter="fn_search_myPrescribe">
                                            </li>
                                            <li>
                                                <div class="form_select w100" style="gap: 10px">
                                                    <p>카테고리</p>
                                                    <b-form-select v-model="searchMyPrescribe.prescribe_category" class="flex-fill" @change="fn_myPrescribe_category_change">
                                                        <b-form-select-option value="">선택</b-form-select-option>
                                                        <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                                                    </b-form-select>
                                                    <b-form-select v-model="searchMyPrescribe.prescribe_sub_category" class="flex-fill" @change="fn_myPrescribe_page_init">
                                                        <b-form-select-option value="">선택</b-form-select-option>
                                                        <b-form-select-option v-for="(item, index) in prescrbeMySubCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                            </li>
                                            <li>
                                                <button class="btn btn_md btn_outline" @click="fn_search_myPrescribe">검색</button>
                                            </li>
                                        </ul>
                                        <div class="form_select">
                                            <ul class="filter_kr">
                                            <li v-for="(item, index) in filterKR" :key="index"
                                                :class="{ on:index === searchMyPrescribe.filterIndex}"
                                                @click="fn_myPrescribe_filter(index)"
                                            >
                                                {{ item }}
                                            </li>
                                            </ul>
                                        </div>
                                        <table class="list fixed_col_list">
                                            <colgroup>
                                                <col style="width:auto">
                                                <col style="width:25%">
                                                <col style="width:80px">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>처방명</th>
                                                    <th>출전</th>
                                                    <th>반영</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="myPrescribelist.length == 0">
                                                    <td colspan="3"><span>데이터가 없습니다.</span></td>
                                                </tr>
                                                <tr
                                                    v-for="(item, index) in myPrescribelist" :key="index"                                                
                                                    :class="{ active:gridSelect.selfDictionary === index }"
                                                >
                                                    <td @click="fn_show_myPrescribe_detail(item,index)"><span>{{ item.prescribe_nm }}</span></td>
                                                    <td @click="fn_show_myPrescribe_detail(item,index)"><span>{{ item.prescribe_source }}</span></td>
                                                    <td><button class="bdge bd_brown" @click="fn_show_myPrescribe_detail(item,index)">반영</button></td>                                                
                                                    <!-- <td><button class="bdge bd_brown" @click="fn_myPrescribe_apply(item),fn_grid_select_myPrescribe(index)">반영</button></td> -->
                                                </tr>
                                            </tbody>
                                        </table>                                    
                                        <myPrescribePagination :pageInfo=searchMyPrescribe.pageInfo @clickPage="fn_move_myPrescribePage" v-show="searchMyPrescribe.myPrescribePageShow"/>
                                    </div>
                                    <!-- 방제사전 -->
                                    <div v-show="tabIndices.medicine === 2">
                                        <ul class="search_filter">
                                            <li>
                                                <p>방제사전검색</p>
                                                <input type="text" placeholder="방제사전을 입력하세요" v-model="searchDictionary.dictionaryNm" class="form_control" @change="fn_dictionary_page_init" @keyup.enter="fn_search_dictionary">
                                                <button class="btn btn_md btn_outline" @click="fn_search_dictionary">검색</button>
                                            </li>
                                        </ul>
                                        <div class="form_select">
                                            <ul class="filter_kr">
                                            <li v-for="(item, index) in filterKR" :key="index"
                                                :class="{ on:index === searchDictionary.filterIndex }"
                                                @click="fn_dictionary_filter(index)"
                                            >
                                                {{ item }}
                                            </li>
                                            </ul>
                                        </div>
                                        <table class="list fixed_col_list">
                                            <colgroup>
                                                <col style="width:auto">
                                                <col style="width:20%">
                                                <col style="width:20%">
                                                <col style="width:80px">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>처방명</th>
                                                    <th>한자명</th>
                                                    <th>출전</th>
                                                    <th>반영</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="dictionarylist.length == 0">
                                                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                                                </tr>
                                                <tr
                                                    v-for="(item, index) in dictionarylist" :key="index"                                                
                                                    :class="{ active:gridSelect.dictionary === index }"
                                                >
                                                    <td @click="fn_dictionary_detail(item,index)"><span>{{ item.dictionary_nm }}</span></td>
                                                    <td @click="fn_dictionary_detail(item,index)"><span>{{ item.dictionary_chinese_nm }}</span></td>
                                                    <td @click="fn_dictionary_detail(item,index)"><span>{{ item.dictionary_source }}</span></td>
                                                    <td><button class="bdge bd_brown" @click="fn_dictionary_detail(item,index)" >반영</button></td>
                                                    <!-- <td><button class="bdge bd_brown" @click="fn_dictionary_apply(item),fn_grid_select_dictionary(index)" >반영</button></td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                        <dictionaryPagination :pageInfo=searchDictionary.pageInfo @clickPage="fn_move_dictionaryPage" v-show="searchDictionary.dictionaryPageShow"/>
                                    </div>
                                    <!-- 비방사전 -->
                                    <div v-show="tabIndices.medicine === 3">
                                        <ul class="search_filter">
                                            <li>
                                                <p>비방사전검색</p>
                                                <input type="text" placeholder="비방사전을 입력하세요" v-model="searchScretDictionary.scretDictionaryNm" class="form_control" @change="fn_scretDictionary_page_init" @keyup.enter="fn_search_scretDictionary">
                                              </li>
                                              <li>
                                                <p>적응증</p>
                                                <input type="text" placeholder="적응증을 입력하세요" v-model="searchScretDictionary.indications" class="form_control" @change="fn_scretDictionary_page_init" @keyup.enter="fn_search_scretDictionary">
                                              </li>
                                              <li>
                                                <div class="form_select w100" style="gap: 10px">
                                                    <p>카테고리</p>
                                                    <b-form-select v-model="searchScretDictionary.prescribe_category" class="flex-fill" @change="fn_scretDictionary_category_change">
                                                        <b-form-select-option value="">선택</b-form-select-option>
                                                        <b-form-select-option v-for="(item, index) in prescrbeCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                                                    </b-form-select>
                                                    <b-form-select v-model="searchScretDictionary.prescribe_sub_category" class="flex-fill" @change="fn_scretDictionary_page_init">
                                                        <b-form-select-option value="">선택</b-form-select-option>
                                                        <b-form-select-option v-for="(item, index) in prescrbeScretSubCategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                            </li>
                                            <li>
                                                <button class="btn btn_md btn_outline" @click="fn_search_scretDictionary">검색</button>
                                            </li>
                                        </ul>
                                        <div class="form_select">
                                            <ul class="filter_kr">
                                            <li v-for="(item, index) in filterKR" :key="index"
                                                :class="{ on:index === searchScretDictionary.filterIndex }"
                                                @click="fn_scretDictionary_filter(index)"
                                            >
                                                {{ item }}
                                            </li>
                                            </ul>
                                        </div>
                                        <table class="list scret_dictionary_list">
                                            <colgroup>
                                                <col style="width:auto">
                                                <col style="width:20%">
                                                <col style="width:120px">
                                                <col style="width:80px">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>처방명</th>
                                                    <th>카테고리</th>
                                                    <th>출전</th>
                                                    <th>반영</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="scretDictionarylist.length == 0">
                                                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                                                </tr>
                                                <tr
                                                    v-for="(item, index) in scretDictionarylist" :key="index"
                                                    :class="{ active:gridSelect.scretDictionary === index }"
                                                >
                                                    <td @click="fn_scretDictionary_detail(item,index)"><span>{{ item.prescribe_nm }}</span></td>
                                                    <td @click="fn_scretDictionary_detail(item,index)"><span>{{ item.prescribe_category_nm }}</span></td>
                                                    <td @click="fn_scretDictionary_detail(item,index)"><span :title="item.prescribe_source">{{ item.prescribe_source }}</span></td>
                                                    <td><button class="bdge bd_brown" @click="fn_scretDictionary_detail(item,index)" >반영</button></td>
                                                    <!-- <td><button class="bdge bd_brown" @click="fn_dictionary_apply(item),fn_grid_select_dictionary(index)" >반영</button></td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                        <scretDictionaryPagination :pageInfo=searchScretDictionary.pageInfo @clickPage="fn_move_scretDictionaryPage" v-show="searchScretDictionary.scretDictionaryPageShow"/>
                                    </div>
                                    <!-- 이전처방 -->
                                    <div v-show="tabIndices.medicine === 4">
                                        <ul class="search_filter">
                                            <li>
                                                <p>기간</p>
                                                <Datepicker v-model="searchPrePrescribe.startDate"  :defaultDate="searchPrePrescribe.startDate" :format="'YYYY-MM-DD'" @change="fn_page_init"/> 
                                                <span>~</span>
                                                <Datepicker v-model="searchPrePrescribe.endDate" :defaultDate="searchPrePrescribe.endDate" :format="'YYYY-MM-DD'" @change="fn_page_init"/> 
       
       
       
                                            </li> 
                                            <li>
                                                <p>이전처방검색</p>
                                                <input type="text" placeholder="이전처방검색을 입력하세요"  v-model="searchPrePrescribe.prescribe_nm" class="form_control" @change="fn_page_init" @keyup.enter="fn_search_prePrescribe">
                                                <button class="btn btn_md btn_outline" @click="fn_search_prePrescribe">검색</button>
                                            </li>
                                        </ul>
                                        <div class="form_select">
                                            <ul class="filter_kr">
                                            <li v-for="(item, index) in filterKR" :key="index"
                                                :class="{ on:index === tabIndices.filterTab3}"
                                                @click="fn_prePrescribe_filter(index)"
                                            >
                                                {{ item }}
                                            </li>
                                            </ul>
                                        </div>
                                        <table class="list fixed_col_list">
                                            <colgroup>
                                                <col style="width:auto">
                                                <col style="width:20%">
                                                <col style="width:20%">
                                                <col style="width:80px">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>처방명</th>
                                                    <th>처방일</th>
                                                    <th>환자명</th>
                                                    <th>반영</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="prePrescribelist.length == 0">
                                                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                                                </tr>
                                                <tr
                                                    v-for="(item, index) in prePrescribelist" :key="index"
                                                    :class="{ active:gridSelect.beforeReceipt === index }"
                                                >
                                                    <td @click="fn_prePrescribe_detail(item,index)"><span>{{ item.prescribe_nm }}</span></td>
                                                    <td @click="fn_prePrescribe_detail(item,index)"><span>{{ item.prescribe_dt }}</span></td>
                                                    <td @click="fn_prePrescribe_detail(item,index)"><span>{{ item.patient_nm }}</span></td>
                                                    <td><button class="bdge bd_brown" @click="fn_prePrescribe_detail(item,index)">반영</button></td>
                                                    <!-- <td><button class="bdge bd_brown" @click="fn_prePrescribe_apply(item),fn_grid_select_beforeReceipt(index)">반영</button></td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                        <prePrescribePagination :pageInfo=searchPrePrescribe.pageInfo @clickPage="fn_move_prePrescribePage" v-show="searchPrePrescribe.prePrescribePageShow"/>
                                        <!-- <Pagination /> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 약재 검색 -->
                            <div class="search" v-show="isShow.mediSearch" @scroll.passive="onScroll">
                                <div class="table_list">
                                    <div class="detail">
                                        <div class="title_sm pt0">
                                            <h3 class="tb_title">{{medicineInfo.med_hrb_nm}}</h3>
                                            <button @click="isShow.mediSearch = false">
                                                <b-icon icon="x"></b-icon>
                                            </button>
                                        </div>
                                        <table class="write">
                                            <colgroup>
                                                <col width="100">
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>약재명</th>
                                                    <td><span>{{medicineInfo.med_hrb_nm}}</span></td>
                                                </tr>
                                                <tr>
                                                    <th>설명</th>
                                                    <td><span>{{medicineInfo.med_prfm}}</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fix" ref="test_scroll" style="margin-bottom: 120px;" :style="{'transform' : 'translateY('+ tranformPx +'px)'}" v-show="isShow.totalParice" >
                            <div class="search">
                                <div class="table_list">
                                    <div class="detail">
                                        <div class="title_sm pt0">
                                            <h3 class="tb_title">예상 결제 비용</h3>
                                        </div>
                                        <table class="write">
                                            <colgroup>
                                                <col width="100">
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>약재비</th>
                                                    <td>{{application.sum_chup_qy}}g × {{application.chup_cnt}}첩 = {{application.total_medicin_qy}}g</td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                    <th>조제비</th>
                                                    <td>{{price.pouchPrice}}원 × {{application.packCnt}}팩</td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_prepare_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                    <th>탕전비</th>
                                                    <td>{{application.packQy}}ml × {{application.packCnt}}팩 = {{application.packQy * application.packCnt}}ml</td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_tangjeon_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                    <th>제품비</th>
                                                    <td>파우치비용+포장비용+박스비용</td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_product_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                    <th>기타비</th>
                                                    <td>{{application.etcText}}</td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_etc_price) }}원</span></td>
                                                </tr>
                                                <tr>
                                                    <th>배송비</th>
                                                    <td></td>
                                                    <td class="ar"><span>{{ fn_comma_won(application.total_delivery_price) }}원</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table class="write bn">
                                            <colgroup>
                                                <col width="130">
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>총 결제 비용</th>
                                                    <td class="ar">
                                                        <span>{{ fn_comma_won(application.total_price  + application.total_prepare_price + application.total_tangjeon_price + application.total_product_price + application.total_etc_price + application.total_delivery_price) }}원</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div> 


                    </div>
                    <div class="bottom_box">
                        <div class="btn_box">
                            <button class="btn btn_md btn_brown" @click="fn_application_reg" v-if="clinicDoctorClass == 'C'">처방전 접수</button>
                        </div>
                    </div> 
                </div>

                <!-- 복용법  -->
                <div class="tab_contents" v-show="currentMenu === 1">
                     <div class="lay_left">
                        <p class="mb20">"기타"를 클릭하여 유의할 사항을 적어주시면 복용법에 같이 출력됩니다.</p>
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="*">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>환자정보</th>
                                        <td><span>{{ selectPetientInfo.patient_nm }}</span><span v-if="selectPetientInfo.patient_gender_nm !== ''"> / {{ selectPetientInfo.patient_gender_nm }}</span><span> / {{ selectPetientInfo.patient_chart_no  }}</span></td>
                                    </tr>
                                    <tr v-for="(item, idx) in howTake" :key="idx">
                                        <th>
                                            <span :class="item.require ? 'emp' : '' ">
                                                {{ item.th }}
                                            </span>
                                        </th>
                                        <td>
                                            <div class="suggest_list">
                                                <b-form-checkbox-group
                                                    v-if="item.mode === 'select'"
                                                    @change="(evt) => onChangeLabel(evt, item, idx)"
                                                    v-model="item.selected"
                                                    :options="item.data"
                                                    name="checkbox"
                                                    buttons
                                                />
                                                <b-form-radio-group
                                                    v-else                                                  
                                                    @change="(evt) => onChangeLabel(evt, item, idx)"
                                                    v-model="item.selected"
                                                    :options="item.data"
                                                    name="radios-btn-default"
                                                    buttons
                                                >
                                                </b-form-radio-group>
                                                <button 
                                                    v-if="item.mode === 'upload'"
                                                    @click="fn_click_upload"
                                                    class="btn btn_md btn_darkbrown ml10"
                                                >
                                                    파일 업로드
                                                </button>
                                                <div
                                                    v-if="isEtcSelected(item)"
                                                >
                                                    <input
                                                        type="text"
                                                        class="form_control mt10"
                                                        placeholder="내용을 입력해주세요"
                                                        v-model="item.etcMsg"
                                                    >
                                                </div>
                                            </div>                                            
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>한의원 정보</span></th>
                                        <td>
                                            <input type="text" class="form_control" placeholder="상호명" v-model="application.howTake_clinic_name">
                                            <input type="text" class="form_control mt10" placeholder="전화번호" v-model="application.howTake_clinic_tel">
                                            <input type="text" class="form_control mt10" placeholder="주소" v-model="application.howTake_clinic_address">
                                            <div class="info_txt fwb">
                                                상호, 전화번호, 주소를 입력하지 않으면 복용법에 출력되지 않습니다.
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>파일 업로드</span></th>
                                        <td>
                                            <p v-if="application.howTakeFileNm == ''">데이터가 없습니다.</p>
                                            <ul v-else class="file_list" style="flex-direction: column; align-items: flex-start;">
                                                <li>
                                                    {{application.howTakeFileNm}}
                                                    <button class="bdge bd_red" @click="fn_howtake_file_delete">삭제</button>
                                                </li>
                                            </ul>
                                            <input type="file" ref="howTakeFile" @change="fn_fileHowTakeChange" hidden>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="bottom_box">
                        <div class="btn_box">
                            <button class="btn btn_md btn_brown btn_outline" @click="currentMenu = 0">이전 단계</button>
                            <button 
                                v-if="howTake[0].selected === 'format'" 
                                class="btn btn_md btn_darkbrown" 
                                v-b-modal.howTakePrintModal
                                >
                                    전용서식 미리보기
                                </button>
                            <button class="btn btn_md btn_brown" @click="fn_move_delivery">배송신청</button>
                        </div>
                    </div>                    
                </div>

                <!-- 탕제 신청 확인 -->
                <div class="tab_contents" v-show="currentMenu === 2">
                    <div class="lay_left">
                        <div class="table_list">
                            <table class="list no_view">
                               <thead>
                                    <tr>
                                        <th>처방분류</th>
                                        <th>급여구분</th>
                                        <th>처방일자</th>
                                        <th>처방기관</th>
                                        <th>처방의</th>
                                        <th>조제의뢰처</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span>{{application.prescribe_type_nm}}</span></td>
                                        <td><span>급여</span></td>
                                        <td><span>2024-01-05</span></td>
                                        <td><span>{{application.clinic_nm}}</span></td>
                                        <td><span>{{application.doctor_nm}}</span></td>
                                        <td><span>코끼리 원외탕전</span></td>                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 환자 정보 -->
                        <div class="table_list">
                            <h3 class="tb_title">환자</h3>
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>

                                    <tr>
                                        <th><span>환자 정보</span></th>
                                        <td><span>{{selectPetientInfo.patient_nm}}</span> </td>
                                        <th><span>차트 번호</span></th>
                                        <td><span>{{selectPetientInfo.patient_chart_no}}</span> </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 처방전 -->
                        <div class="table_list">
                            <h3 class="tb_title">처방전</h3>
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>처방명</span></th>
                                        <td><span>{{application.prescribe_nm}}</span></td>
                                    </tr>
                                    <tr>
                                        <th><span>약재구성</span></th>
                                        <td><span>{{med_list}}</span></td>
                                    </tr>
                                    <tr>
                                        <th><span>감미제적용</span></th>
                                        <td>
                                            <span v-if="application.sweetener == '0'">사용안함</span>
                                            <span v-if="application.sweetener == '1'">단맛1단계</span>
                                            <span v-if="application.sweetener == '2'">단맛2단계</span>
                                            <span v-if="application.sweetener == '3'">단맛3단계</span>
                                            <span v-if="application.sweetener == '4'">단맛4단계</span>
                                        </td>
                                        <th><span>향기</span></th>
                                        <td>
                                            <span v-if="application.sweet_flavor == ''">사용안함</span>
                                            <span v-if="application.sweet_flavor == 'CA1'">약한카라멜향(0.5%)</span>
                                            <span v-if="application.sweet_flavor == 'CA2'">약한카라멜향(1%)</span>
                                            <span v-if="application.sweet_flavor == 'SB1'">약한딸기향(0.5%)</span>
                                            <span v-if="application.sweet_flavor == 'SB2'">약한딸기향(1%)</span>
                                            <span v-if="application.sweet_flavor == 'CH1'">약한초코향(0.5%)</span>
                                            <span v-if="application.sweet_flavor == 'CH2'">약한초코향(1%)</span>
                                        </td>   
                                    </tr>
                                    <tr>
                                        <th><span>녹용 앰플</span></th>
                                        <td>
                                            <span v-if="application.ny_ampul == '0'">사용안함</span>
                                            <span v-if="application.ny_ampul != '0'">{{application.ny_ampul}}ml</span>
                                        </td>
                                        <th><span>자하거&#40;앰플&#41;</span></th>
                                        <td>
                                            <span v-if="application.jhg == '0'">사용안함</span>
                                            <span v-if="application.jhg != '0'">{{application.jhg}}ml</span>
                                        </td>   
                                    </tr>
                                    <tr>
                                        <th><span>총약재량</span></th>
                                        <td><span>{{application.sum_chup_qy}}g x {{application.chup_cnt}}첩 = {{application.total_medicin_qy}}g</span></td>
                                        <th><span>첩수/용량</span></th>
                                        <td><span>{{application.packCnt}}팩 / {{application.packQy}}ml</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- 포장 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="80%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>파우치</span></th>
                                        <td>
                                            <div class="img_list">
                                                <div>
                                                    <img :src="'/file/getImgFile/' + application.pouchImgInfo.wrapper_file_id" alt="">
                                                    <p>{{ application.pouchImgInfo.wrapper_nm }}</p>
                                                </div>
                                            </div>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>포장방식</span></th>
                                        <td>
                                            <div class="img_list">
                                                <div>
                                                  <img :src="'/file/getImgFile/' + application.wrapperImgInfo.wrapper_file_id" alt="">
                                                  <p>{{ application.wrapperImgInfo.wrapper_nm }}</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>박스</span></th>
                                        <td>
                                            <div class="img_list">
                                                <div>
                                                    <img :src="'/file/getImgFile/' + application.boxImgInfo.wrapper_file_id" alt="">
                                                    <p>{{ application.boxImgInfo.wrapper_nm }}</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>마킹</span></th>
                                        <td>
                                            <span v-if="application.mark_yn == 'N'">사용안함</span>
                                            <span v-if="application.mark_yn == 'Y'">환자이름,조제날짜</span>                                           
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>포장요구사항</span></th>
                                        <td colspan="3">
                                            <textarea name="" id="" class="form_control" v-model="application.wrapperReq" readonly></textarea>                                            
                                        </td>
                                    </tr>                                    
                                </tbody>
                            </table>
                        </div>
                        <!-- 조제 지시 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th><span>조제지시</span></th>
                                        <td colspan="3">
                                            <textarea name="" id="" class="form_control" v-model="application.instructions" readonly></textarea>                                            
                                        </td>
                                    </tr>                                    
                                </tbody>
                            </table>
                        </div>

                        <!-- 복용법 -->
                        <div class="table_list">
                            <table class="write">
                                <colgroup>
                                    <col width="200">
                                    <col width="30%">
                                    <col width="200">
                                    <col width="30%">
                                </colgroup>
                                <tbody>                                    
                                    <tr>
                                        <th><span>복용법</span></th>                                        
                                        <td v-if="application.howTakeFileNm == ''">{{howTake[0].label}}</td>
                                        <td v-if="application.howTakeFileNm != ''">파일업로드</td>
                                    </tr>
                                    <tr v-if="howTake[0].selected=='format'">
                                        <th>복용방법</th>
                                        <td>{{howTake[1].label}} <span v-if="howTake[1].label === '기타'"> : {{howTake[1].etcMsg}}</span></td>
                                    </tr>
                                    <tr v-if="howTake[0].selected=='format'">
                                        <th>복용시간</th>
                                        <td>{{howTake[2].label}} <span v-if="howTake[2].label === '기타'"> : {{howTake[2].etcMsg}}</span></td>
                                    </tr>
                                    <tr v-if="howTake[0].selected=='format'">
                                        <th>복용온도</th>
                                        <td>{{howTake[3].label}}</td>
                                    </tr>
                                    <tr v-if="howTake[0].selected=='format'">
                                        <th>금지음식</th>
                                        <td>{{howTake[4].label}}</td>
                                    </tr>
                                    <tr v-if="howTake[0].selected=='format' && howTake[4].etcMsg != ''">
                                        <th>기타금지음식</th>
                                        <td>{{howTake[4].etcMsg}}</td>
                                    </tr>
                                    <tr v-if="application.howTakeFileNm != ''">
                                        <th>파일첨부</th>
                                        <td class="file_list">{{application.howTakeFileNm}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="lay_right">
                        <div class="search">
                            <div class="table_list">
                                <div class="title_sm pt10 pb10">
                                    <h3 class="tb_title">배송 정보</h3>
                                </div>
                                
                                <table class="write">
                                    <colgroup>
                                        <col width="30%">
                                        <col width="70%">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>발송 모드</th>
                                            <td>
                                                <div class="form_select">
                                                    <b-form-select v-model="application.deliveryType" class="w100" @change="fn_change_delivery_type">
                                                        <b-form-select-option value="TTC">탕전실 > 한의원</b-form-select-option>
                                                        <b-form-select-option value="CTP">한의원 > 환자</b-form-select-option>
                                                        <b-form-select-option value="TTP">탕전실 > 환자</b-form-select-option>
                                                        <b-form-select-option value="TTT">탕전실 직접수령</b-form-select-option>
                                                        <b-form-select-option value="ETC">직접입력</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table_list">
                                <div class="title_sm pt10 pb10">
                                    <h3 class="tb_title">보내는 사람</h3>
                                </div>
                                <table class="write">
                                    <colgroup>
                                        <col width="30%">
                                        <col width="70%">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>발신인</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_nm"></td>
                                        </tr>                                    
                                        <tr>
                                            <th>연락처</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_tel_num"></td>
                                        </tr>
<!--                                        <tr>-->
<!--                                            <th>휴대폰</th>-->
<!--                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_phone_num"></td>-->
<!--                                        </tr>       -->
                                        <tr>
                                            <th>우편번호</th>
                                            <td>
                                                <div class="form_inline">
                                                    <input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_post_no">
                                                    <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('send')">검색</button>                                                
                                                </div>
                                            </td>
                                        </tr>   
                                        <tr>
                                            <th>주소</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_addr"></td>
                                        </tr>
                                        <tr>
                                            <th>상세주소</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.send_addr_dtl"></td>
                                        </tr>                                       
                                    </tbody>
                                </table>
                            </div>
                            <div class="table_list">
                                <div class="title_sm pt10 pb10">
                                    <h3 class="tb_title">받는 사람</h3>
                                </div>
                                <table class="write">
                                    <colgroup>
                                        <col width="30%">
                                        <col width="70%">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>수신인</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_nm" ></td>
                                        </tr>                                    
                                        <tr>
                                            <th>연락처</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_tel_num"></td>
                                        </tr>
                                        <tr>    
                                            <th>휴대폰</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_phone_num"></td>
                                        </tr>       
                                        <tr>
                                            <th>우편번호</th>
                                            <td>
                                                <div class="form_inline">
                                                    <input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_post_no">
                                                    <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('recive')">검색</button>                                                
                                                </div>
                                            </td>
                                        </tr>   
                                        <tr>
                                            <th>주소</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_addr"></td>
                                        </tr>
                                        <tr>    
                                            <th>상세주소</th>
                                            <td><input type="text" class="form_control" placeholder="입력해주세요" v-model="application.receive_addr_dtl"></td>
                                        </tr>                                       
                                    </tbody>
                                </table>
                            </div>
                            
                            <div class="table_list">
                                <div class="title_sm pt10 pb10">
                                    <h3 class="tb_title">기타 정보</h3>
                                </div>
                                <table class="write">
                                    <colgroup>
                                        <col width="30%">
                                        <col width="70%">
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th><span>배송메모</span></th>
                                            <td>
                                                <textarea name="" id="" class="form_control" placeholder="입력해주세요." v-model="application.deliveryMemo"></textarea>                                            
                                            </td>
                                        </tr>                                    
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="search">   
                            <div class="table_list">
                                <div class="detail">
                                    <div class="title_sm pt0">
                                        <h3 class="tb_title">예상 결제 비용</h3>
                                    </div>
                                    <table class="write">
                                        <colgroup>
                                            <col width="100">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>약재비</th>
                                                <td>{{application.sum_chup_qy}}g × {{application.chup_cnt}}첩 = {{application.total_medicin_qy}}g</td>
                                                <td class="ar"><span>{{ fn_comma_won(application.total_price) }}원</span></td>
                                            </tr>
                                            <tr>
                                                <th>조제비</th>
                                                <td>{{price.pouchPrice}}원 × {{application.packCnt}}팩</td>
                                                <td class="ar"><span>{{ fn_comma_won(application.total_prepare_price) }}원</span></td>
                                            </tr>
                                            <tr>
                                                <th>탕전비</th>
                                                <td>{{application.packQy}}ml × {{application.packCnt}}팩 = {{application.packQy * application.packCnt}}ml</td>
                                                <td class="ar"><span>{{ fn_comma_won(application.total_tangjeon_price) }}원</span></td>
                                            </tr>
                                            <tr>
                                                <th>제품비</th>
                                                <td>파우치비용+포장비용+박스비용</td>
                                                <td class="ar"><span>{{ fn_comma_won(application.total_product_price) }}원</span></td>
                                            </tr>
                                            <tr>
                                                <th>기타비</th>
                                                <td>{{application.etcText}}</td>
                                                <td class="ar"><span>{{ fn_comma_won(application.total_etc_price) }}원</span></td>
                                            </tr>
                                            <tr>
                                                <th>배송비</th>
                                                <td></td>
                                                <td class="ar"><span>{{ fn_comma_won(application.total_delivery_price) }}원</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="write bn">
                                        <colgroup>
                                            <col width="130">
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <th>총 결제 비용</th>
                                                <td class="ar">
                                                    <span>{{ fn_comma_won(application.total_price  + application.total_prepare_price + application.total_tangjeon_price + application.total_product_price + application.total_etc_price + application.total_delivery_price) }}원</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom_box">
                        <div class="btn_box">
                            <button class="btn btn_md btn_brown btn_outline" @click="currentMenu = 1">이전 단계</button>
                            <button class="btn btn_md btn_brown" @click="fn_reg_appication_confirm">접수</button>
                        </div>
                    </div>                   
                </div>                  
            </article>
            <petientWriteModal
                :title="'환자 간편 등록'"
                @callback="fn_patientWtrite_callback"
            />
            <medicineDetailModal 
                :title="'약재 정보'"
                :medicineData="medicineDetailData"
                @callback="fn_add_medicine"
            />
            <patientPrescribeDetailModal 
                :title="'환자처방정보'"
                :patientPrescribeData="patientPrescribeInfo"
                @callback="fn_patient_prescribe_apply"
            />
            <myPrescribeDetailModal 
                :title="'개인방제정보'"
                :myPrescribeData="myPrescribeInfo"
                @callback="fn_myPrescribe_apply"
            />
            <dictionaryDetailModal 
                :title="'방제사전정보'"
                :dictionaryData="dictionaryInfo"
                @callback="fn_dictionary_apply"
            />
            <scretDictionaryDetailModal 
                :title="'비방사전정보'"
                :scretDictionaryData="scretDictionaryInfo"
                @callback="fn_scretDictionary_apply"
            />
            <prePrescribeDetailModal 
                :title="'이전처방정보'"
                :prePrescribeData="prePrescribeInfo"
                @callback="fn_prePrescribe_apply"
            />
            <myPrescribeRegModal 
                :title="'개인방제 등록'"
                :myPrescribeData="myPrescribeRegData"                
            />
            <howTakePrintModal
            :application="application"
            :data="howTake"
            :printView="true"
            />
            <AlertModal
                :id="'alert'"
                :text="showAlertMsg" 
                :btnRight="'확인'" 
                :oneBtn="false"
                :isShow="showAlert"
                :className="'btn_brown'"
                v-on:update:showSetting="fn_showSet"
            />
            <AlertModal 
                :id="'confirm'"
                :text="alertMsg" 
                :btnLeft="'취소'" 
                :btnRight="'확인'" 
                :oneBtn="true"
                :isShow="initAlertShow"
                :className="'btn_brown'"
                @callback="fn_alert_close"
            />   
    </div>
                   
</template>

<script>
    //import Pagination from "@/components/AdminPagination.vue"
    import PetientPagination from "@/components/AdminPagination.vue"
    import prescribePagination from "@/components/AdminPagination.vue"
    import medicinePagination from "@/components/AdminPagination.vue" 
    import myPrescribePagination from "@/components/AdminPagination.vue"
    import dictionaryPagination from "@/components/AdminPagination.vue"
    import scretDictionaryPagination from "@/components/AdminPagination.vue"
    import prePrescribePagination from "@/components/AdminPagination.vue"
    import UserStep from "@/components/user/UserStep.vue"
    import axios from 'axios'
    import petientWriteModal from '@/modal/user/petientWriteModal.vue'
    import medicineDetailModal from '@/modal/user/medicineDetailModal.vue'
    import patientPrescribeDetailModal from '@/modal/user/patientPrescribeDetailModal.vue'
    import myPrescribeDetailModal from '@/modal/user/myPrescribeDetailModal.vue'
    import dictionaryDetailModal from '@/modal/user/dictionaryDetailModal.vue'
    import scretDictionaryDetailModal from '@/modal/user/scretDictionaryDetailModal.vue'
    import prePrescribeDetailModal from '@/modal/user/prePrescribeDetailModal.vue'
    import myPrescribeRegModal from '@/modal/user/myPrescribeRegModal.vue'
    import commonUtil from "@/mixin/commonUtil";
    import Datepicker from '@/components/Datepicker.vue'
    import { nextTick } from 'vue'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";

    import { 
        format,
        count,
        time,
        temperature,
        forbidden
    } from '@/data/user/takingData'

    import howTakePrintModal from "@/modal/common/howTakePrintModal.vue"

    export default {
        name : 'ApplictionHerbMedicine',
        mixins: [commonUtil,alertutill],
        components: {
            //Pagination,
            PetientPagination,  //환자검색 페이징 - #환자검색
            prescribePagination, //처방내역 페이징
            medicinePagination,     // 약재 페이징
            myPrescribePagination,  // 개인방제 페이징
            dictionaryPagination,      //방제사전 페이징
            scretDictionaryPagination, //비방사전 페이징
            prePrescribePagination,     //이전처방 페이징
            UserStep,
            petientWriteModal,
            medicineDetailModal,
            patientPrescribeDetailModal,
            myPrescribeDetailModal,
            myPrescribeRegModal,
            dictionaryDetailModal,
            scretDictionaryDetailModal,
            prePrescribeDetailModal,
            howTakePrintModal,
            Datepicker,
            AlertModal            
        },
        watch: {
            searchItem (item) {
                if (item === '') {
                    this.searchAutoBox = false
                }
            },
            currentMenu (menu) {
                this.userStep.forEach(menuItem => {
                    menuItem.class = undefined
                })
                this.userStep[menu].class = 'on'
            },
            // howTake : {
            //     deep: true,
            //     handler (data) {

            //         console.log("@@@@@ 1111");
            //         if (this.isEtcSelected(data[4])) {
            //             let itemMap = data[4].data.reduce((map, item) => {
            //                 map[item.value] = item.text
            //                 return map
            //             }, {})

            //             if (typeof data[4].selected === 'object') {
            //                 let selectedTexts = data[4].selected.map(value => {
            //                     // if (itemMap[value] === '기타') {
            //                     //     return data[4].etcMsg
            //                     // }
            //                     return itemMap[value]
            //                 })

            //                 selectedTexts = selectedTexts.filter((value) => value !== '기타');
            //                 data[4].label = selectedTexts.join()
            //             }
            //         }
            //     }
            // }
        },
        created(){


            let clinicDoctorId = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];

            console.log("@@@@@ clinicDoctorId : "+clinicDoctorId);

            if(clinicDoctorId == null || clinicDoctorId == ''){
                this.$router.push({ name: 'UserLogin'}); 
            }

            // 팩수 리스트 만들기
            for(let i = 5; i <= 120; i++){
                this.packlist.push(i);
            }                  
            
            //this.application.doctorNm = this.$store.getters['clinicDoctorInfo/getDoctorNm']                        
            this.application.doctor_nm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];
            this.application.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
            this.application.clinic_nm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
            this.application.clinic_tel = this.$store.getters['clinicDoctorInfo/getClinicTelNum']; 
            this.application.clinic_addr = this.$store.getters['clinicDoctorInfo/getClinicAddr'];               //처방기관
            this.application.clinic_addr_detail =this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'];        
            this.clinicDoctorClass = this.$store.getters['clinicDoctorInfo/getClinicDoctorClass'];

        },
        mounted () {
            this.fn_init();

            //this.leftArea = this.$refs['leftRef'].offsetHeight
            //20250402- 환자검색 계속노출
            this.isShow.patient     = true;
            this.tabIndices.patient = 2;
            this.fn_search_patient(false);

            //20250402- 약재검색 계속노출
            this.isShow.medicine = true;
            this.tabIndices.medicine = 2;
            
            // 스크롤 이벤트 적용
            //document.addEventListener('scroll', this.scrollEvents);
            //재신청 정보 조회
            let rePresciptSeq = this.$store.getters['applicationInfo/getRePresciptSeq']; 
            if(rePresciptSeq != null && rePresciptSeq !=""){
               this.fn_represcribe(rePresciptSeq);
            }

        },
        unmounted() {
            //스크롤 이벤트 제거
            //document.removeEventListener('scroll', this.scrollEvents);
        },
        methods: {
          async  fn_init(){
              //초기화 정보 조회
              this.fn_search_pouchImg();
              this.fn_search_wrapperImg();
              this.fn_search_boxImg();

              this.fn_search_myPrescribe();
              this.fn_search_dictionary();
              this.fn_search_scretDictionary();
              this.fn_search_prePrescribe();

              // 카테고리 정보
              this.prescrbeCategoryList = await this.getCode('GC00000015');

              console.log("####### this.prescrbeCategoryList : %o", this.prescrbeCategoryList);

              //환자 처방이력 기본정보 셋팅
              this.searchPatientPrescribe.clinic_doctor_id = this.application.clinic_doctor_id;
              this.searchPatientPrescribe.prescribe_type = this.application.prescribe_type;

            },
            // scrollEvents(){
            //     // console.log("window.scrollY : %o",window.scrollY);
            //     // console.log("sShow : %o",this.isShow.totalParice );

            //     if(this.isShow.totalParice && window.scrollY > 1260){
            //         //여기까지
            //         this.div_place = this.$refs.test_scroll.getBoundingClientRect();

            //         console.log("div hight :"+ this.div_place.bottom);

            //         this.tranformPx = 916 - Math.round(div_place.bottom);

            //         console.log("tranformPx:"+ Number(this.tranformPx));

            //     }
            // },
            /*********************************************************************
             * 탕전신청 - #탕전신청
             *********************************************************************/
            // 처방전 검색 클릭
            fn_search_prescribe(){
                // this.isShow.medicine = true;
                // this.tabIndices.medicine = 2;
                
                if(this.application.prescribe_nm != ""){
                    this.searchDictionary.dictionaryNm = this.application.prescribe_nm;
                    this.fn_search_dictionary();
                }
                
            },
            // 초기화
            fn_search_init(){

                this.alertMsg = "약재 정보를 초기화 하시겠습니까?"
                this.initAlertShow = true;
                this.initInfo = 'medicine'

                // this.isShow.mediSearch = false;
                // this.isShow.totalParice = false;
                // this.application.prescribe_nm = "";
                // this.application.prescribe_source = "";
                // this.application.prescribe_medicine = [];

                // this.application.sum_chup_qy = 0;
                // this.application.total_medicin_qy = 0;
                // this.application.total_price = 0;
                
            },            
            //약재 정보 변경
            fn_change_medicineInfo(idx){
                
                this.application.prescribe_medicine[idx].medicineQy = Math.round(this.application.prescribe_medicine[idx].chupCnt * this.application.chup_cnt);
                this.application.prescribe_medicine[idx].totalPrice = Math.round(this.application.prescribe_medicine[idx].med_sale_prc * this.application.prescribe_medicine[idx].medicineQy);
                
                this.fn_count_chup_qy();
            },
            fn_chk_medList(){

                //비방사전 반영된 처방은 합방 불가
                if(this.application.secret_prescription_seq && this.application.prescribe_medicine.length > 0){
                    let msg = "비방사전이 적용된 처방은 합방할 수 없습니다.";
                    this.fn_open_alert(msg);
                    return false;
                }

                if(this.application.prescribe_medicine.length > 0){
                    if(confirm("합방하시겠습니까?")){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return true;
                }

            },
            // 첩수 및 약재계산
            fn_count_chup_qy(){
                
                let sumChupQy = 0;
                let totalMedicineQy = 0;
                let totalAllPrice = 0;

                //처방약재 첩량 및 총약재 합구하기
                for(let obj of this.application.prescribe_medicine){                    
                    for (let key in obj){
                        if(key == "chupCnt"){
                            //첩량 합구하기
                            sumChupQy = sumChupQy + Number(obj[key]);
                        }
                        if(key == "medicineQy"){

                            //총약재량 구하기
                            totalMedicineQy = totalMedicineQy + Number(obj[key]);
                        }
                        if(key == "totalPrice"){
                            totalAllPrice = Math.round(totalAllPrice + obj[key]);
                        }
                    }
                }
                
                this.application.sum_chup_qy = (sumChupQy.toFixed(2));
                this.application.total_medicin_qy = Math.round(totalMedicineQy);
                this.application.total_price = totalAllPrice;
                
                //강제 
                this.$forceUpdate();
                this.fn_product_count();
                this.fn_chg_packCnt();
                this.fn_etc_count();


                this.isShow.totalParice = true;

            },
            // 조제료 계산
            fn_chg_packCnt(){
                // 조제비 = 펙당 비용 * 팩수
                this.application.total_prepare_price = this.price.preparePrice * this.application.packCnt;
                //제품비용 계산
                this.fn_product_count();
            },
            //제품비용 계산
            fn_product_count(){
                //파우치비 계산
                let pouchPrice = 0;

                if(this.application.pouchImgInfo != null && this.application.pouchImgInfo != {} ){
                    // 파우치 비용 = 파우치 개당 비용 * 팩수
                    pouchPrice = this.application.pouchImgInfo.wrapper_sale_prc * this.application.packCnt
                }

               this.application.total_product_price = pouchPrice + this.application.wrapperImgInfo.wrapper_sale_prc + this.application.boxImgInfo.wrapper_sale_prc;

            },            
            //기타비용 계산
            fn_etc_count(){
                //let etcPrice = 0;
                let etcText = "";

                let sweetPrice = 0;
                if(this.application.sweetener != 0){
                    sweetPrice = this.application.sweetener * this.price.sweetPrice; 

                    etcText = "감미제"
                    
                }
                
                let flavorPrice = 0;
                if(this.application.sweet_flavor != ""){
                    if(this.application.sweet_flavor.slice(-1) == '1'){
                        flavorPrice = this.price.flavoryPrice1;
                    }else{
                        flavorPrice = this.price.flavoryPrice2;
                    }

                    if(etcText == ""){
                        etcText = "향기"
                    }else{
                         etcText = etcText+" + 향기"
                    }
                }

                let nyAmplePrice = 0;
                if(this.application.ny_ampul != 0){
                    nyAmplePrice = (this.application.ny_ampul / 30 ) * this.price.nyAmpulPrice; 
                    if(etcText == ""){
                        etcText = "녹용엠플"
                    }else{
                         etcText = etcText+" + 녹용엠플"
                    }
                }

                let jhgPrice = 0;
                if(this.application.jhg != 0){
                    jhgPrice = (this.application.jhg / 30 ) * this.price.jhgPrice;
                    
                    if(etcText == ""){
                        etcText = "자하거"
                    }else{
                         etcText = etcText+" + 자하거"
                    }
                }

                this.application.total_etc_price = nyAmplePrice + jhgPrice + sweetPrice + flavorPrice;
                this.application.etcText = etcText;

            },
            //첩수 변경
            fn_change_chup_cnt(){
                
                //처방 첩량 변경
                for(let obj of this.application.prescribe_medicine){                    
                    obj.medicineQy = obj.chupCnt * this.application.chup_cnt;  
                    obj.totalPrice = obj.med_sale_prc * obj.medicineQy;                    
                }
                
                this.fn_count_chup_qy();
            },
            //파우치 이미지 선택
            fn_select_pouch_img(item, index){
                this.selectPouchImgIdx = index;
                this.application.pouchImgInfo = item;

                this.fn_product_count();

            },            
            // 포장 이미지 선택
            fn_select_wrapper_img(item, index){
                this.selectWrapperImgIdx = index;
                this.application.wrapperImgInfo = item;

                //상비약 포장일 경우
                if(item.wrapper_cd == "W000000005"){
                    for(let i = 0; i < this.boxImgList.length ; i++){
                        let wrapperCd = this.boxImgList[i].wrapper_cd
                        //상비약 상자 선택 처리
                        if(wrapperCd == "W000000006"){
                            this.selectBoxImgIdx = i;
                            this.application.boxImgInfo = this.boxImgList[i];
                        }
                    }
                }else{
                    //상비약 상자인 경우 (W000000008)
                    if(this.application.boxImgInfo.wrapper_cd == "W000000006"){
                            this.selectBoxImgIdx = 0;
                            this.application.boxImgInfo = this.boxImgList[0];
                    }
                    
                }

                this.fn_product_count();

            },
            //박스 이미지 선택
            fn_select_box_img(item, index){
                /**
                 * 상비약 포장일 경우 상비약 상자만 선택 가능
                 * 상비약 포장이 아닌경우 상비약 상자 선택 불가
                 */
                if(this.application.wrapperImgInfo.wrapper_cd != "W000000005"){                            
                    if(item.wrapper_cd == "W000000006"){
                        this.fn_open_alert("상비약 포장일때만 선택 가능합니다");
                    }else{
                        this.selectBoxImgIdx = index;
                        this.application.boxImgInfo = item;
                    }                
                }else{
                    if(item.wrapper_cd != "W000000006"){
                        this.fn_open_alert("상비약 포장인 경우 상비약 박스만 가능합니다");
                    }else{
                        this.selectBoxImgIdx = index;
                        this.application.boxImgInfo = item;
                    }
                }

                this.fn_product_count();
            },
            //다음단계
            fn_application_reg(){
                
                if(this.application.patient_seq == ''){
                    let msg = "환자정보를 입력하세요";
                    this.fn_open_alert(msg); 
                    return;
                }else if(this.application.prescribe_nm == ''){
                    let msg = "처방명을 입력하세요";
                    this.fn_open_alert(msg); 
                    return;
                }

                const noStockChk = this.application.prescribe_medicine.some(x => x.med_sale_prc === 0);

                if (noStockChk) {                    
                    this.fn_move_focus_medcine();
                    return;
                }

                this.currentMenu = 1;
                this.fn_medicineList_info()
                this.fn_change_delivery_type()
            },
            fn_move_focus_medcine(){
                this.$nextTick(() => {
                    const el = this.$refs.meficineTable;
                    if (!el) return;

                    // table은 기본 focus 대상이 아니라 tabindex 필요
                    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');

                    // "최소한 보이도록" 스크롤 (center 말고 nearest)
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

                    el.focus();
                });

                let msg = "재고가 없는 약재가 있습니다.";
                this.fn_open_alert(msg); 
            },
            // 이미지 확대보여주기
            viewBoxHandler (evt, info, type) {
                this.viewPositionX = evt.target.offsetLeft - 100
                if (type === 'box') this.viewBox = info
                else if (type === 'wrapper') this.viewWrapper = info
                else this.viewPouch = info
            },
            slidePage (type, dir) {
                const key = type + 'Offset'
                const max = Math.max(0, this[type + 'ImgList'].length - 2)
                this[key] = Math.max(0, Math.min(this[key] + dir, max))
            },
            //탕전신청 저장 - 접수전 수취인 정보 확인
            fn_reg_appication_confirm(){
                this.alertMsg = "처방전 수취인 정보를 확인해주세요.\n"
                    + "수취인 : " + this.application.receive_nm + "\n"
                    + "전화번호 : " + this.application.receive_tel_num + "\n"
                    + "휴대폰 : " + this.application.receive_phone_num + "\n"
                    + "주소 : [" + this.application.receive_post_no + "] " + this.application.receive_addr + " " + this.application.receive_addr_dtl

                this.initAlertShow = true;
                this.initInfo = 'receiveInfo'
            },
            //탕전신청 저장
            fn_reg_appication(){

                if(this.application.howTakeFileNm == '' || this.upLoadFile.upFile == ''){
                    
                    console.log("@@@@  탕전신청 저장 req : %o",this.application);

                    axios
                        .post("/api/user/appliction/regApplication", this.application)
                        .then((res) => {
                            console.log("@@@@  탕전신청 저장 res : %o",res);
                            alert("저장되었습니다.");

                            this.$router.push("/mypage/orderCheckoutList");
                            

                        })
                        .catch((err) => console.log(err));
                }else{
                    
                    var frm = new FormData();

                    frm.append("file",this.upLoadFile.upFile);
                    frm.append("key",JSON.stringify(this.application));

                    axios
                        .post("/api/user/appliction/regApplicationWithFile", frm, {
                                "Content-Type": "multipart/form-data",
                                "Accept-Language" : "ko"})
                        .then((res) => {                            
                            console.log("@@@@ res : %o",res);

                            if(res.data.result == "ok"){
                                // let msg = "저장되었습니다";
                                // this.fn_open_alert(msg);
                                alert("저장되었습니다.");

                                this.$router.push("/mypage/orderCheckoutList");
                                //this.fn_move_page();  
                            }else{
                                let msg = res.data.errorMsg;
                                this.fn_open_alert(msg);
                            }                                              
                        })
                        .catch((err) => console.log(err));
                }
            },
            /*********************************************************************
             * 환자검색 - #환자검색
             *********************************************************************/
            //환자정보 초기화
            resetDataPatient () {
                
                this.alertMsg = "환자 정보를 초기화 하시겠습니까?"
                this.initAlertShow = true;
                this.initInfo = 'patient'
            },
            resetDataMedicne (idx) {
                const tabMenuNames = this.tabMenuNames.medicine
                const menus = {
                    '약재': 'medicine',
                    '개인방제': 'selfDictionary',
                    '방제사전': 'dictionary',
                    '이전처방': 'beforeReceipt',
                    '비방사전': 'scretDictionary',                    
                }[tabMenuNames[idx]]

                this.gridSelect[menus] = null
                this.isSearchDetail[menus] = false
                
            },
            //환자검색버튼 클릭
            fn_click_search_petient(){
                this.tabIndices.patient = 2;
                nextTick(() => {
                    this.$refs.inputPatientNm.focus();
                })
                
                this.fn_search_patient(false);
            },
            fn_patient_page_init(){
                this.searchPatient.pageInfo.page = 1;
            },
            // 환자검색 
            async fn_search_patient(move){

                this.searchPatient.searchClinicDoctorId = this.application.clinic_doctor_id;
                // 검색정보가 변경이 되면 페이지 초기화
                if(move != true){
                    this.searchPatient.pageInfo.page = 1;
                }

                await axios
                    .post("/api/user/petient/getPetientList", this.searchPatient)
                    .then((res) => {
                        this.patientList = res.data.petientList;
                        this.searchPatient.pageInfo.totPage = res.data.totCnt;
                        if(this.searchPatient.pageInfo.totPage> 0){
                            this.searchPatient.PatientPageShow = true;                          
                        }else{
                            this.searchPatient.PatientPageShow = false;
                        }                        
                    })
                    .catch((err) => console.log(err));
             },
             //환자검색 페이징처리
             fn_move_patientPage(page){
                
                this.searchPatient.pageInfo.page = page;

                console.log("@@@@@ this.searchPatient : %o",this.searchPatient);

                this.fn_search_patient(true);
             },
             fn_choose_patient(patientInfo){

                this.isUserSelect = true;
                
                //선택된 환자정보
                this.selectPetientInfo = patientInfo;

                this.selectPetientInfo.clinic_doctor_id = this.application.clinic_doctor_id;
                //처방내역 페이징을 위한 처리
                this.selectPetientInfo.pageInfo = {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    }
                this.selectPetientInfo.prescribePageShow = false;
                    

                //화면에 뿌리는 문구
                this.patientViewInfo = patientInfo.patient_nm + '('+patientInfo.patient_gender_nm+'/'+patientInfo.patient_age+') '+patientInfo.patient_chart_no

                //처방 환자 정보 입력
                this.application.patient_seq = patientInfo.patient_seq;
                this.application.patient_name = patientInfo.patient_nm;

                this.tabIndices.patient = 0;

                //환자처방내역 조회호출
                this.searchPatientPrescribe.patient_seq = patientInfo.patient_seq;
                this.fn_search_patient_prescribe();

             },
            //환자 tab
            fn_click_tab(idx){
                this.tabIndices.patient = idx;                
            },
            // 환자처방정보 조회 
            fn_search_patient_prescribe(){
                axios
                    .post("/api/user/petient/getPrescribeList", this.searchPatientPrescribe)
                    .then((res) => {
                        console.log("@@@@ 환자처방 res : %o",res);
                        this.patientPrescribeList = res.data.petientPrescribeList;

                        this.searchPatientPrescribe.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchPatientPrescribe.pageInfo.totPage > 0){
                            this.searchPatientPrescribe.patientPrescribeShow = true;                          
                        }else{
                            this.searchPatientPrescribe.patientPrescribeShow = false;
                        }                        

                    })
                    .catch((err) => console.log(err));
            },
            //환자등록 저장후 콜백
            async fn_patientWtrite_callback(patientSeq){
                await this.fn_search_patient(false);

                this.patientList.forEach((item)=>{
                    if(item.patient_seq == patientSeq){
                        this.fn_choose_patient(item);
                        return;
                    }
                })                        
            },
            // 환자 이전처방
            fn_move_patient_prescribe(page){
                this.searchPatientPrescribe.pageInfo.page = page;
                this.fn_search_patient_prescribe();
            },
            
            //환자처방  상세보기
            fn_show_patient_prescribe_detail(item,index){
                console.log("@@@@ 환차처방 상세 : %o",item);
                this.gridSelect.patientPrescribe = index

                let medicinelist = [];

                axios
                    .post("/api/user/petient/getpatientPrescribeMedicine", item)
                    .then((res) => {
                        console.log("@@@@ 환자처방 상세 res : %o",res);
                        medicinelist = res.data.patientprescribeMedicineList;                        

                        this.patientPrescribeInfo.prescribe_nm = item.prescribe_nm;
                        this.patientPrescribeInfo.prescribe_source = item.prescribe_source;
                        this.patientPrescribeInfo.prescribe_pack_cnt = item.prescribe_pack_cnt;
                        this.patientPrescribeInfo.packs_cnt = item.packs_cnt;
                        this.patientPrescribeInfo.pack_capacity = item.pack_capacity;
                        
                        let medicineInfo = "";
                        console.log("@@@@ medicinelist : %o",medicinelist);

                        for(let i = 0; i < medicinelist.length; i++){
                            if(i == 0){
                                medicineInfo = medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }else{
                                medicineInfo = medicineInfo + "," + medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }
                        }
                        
                        this.patientPrescribeInfo.prescribe_medicine = medicineInfo;
                        this.patientPrescribeInfo.item = item;
                        
                        this.$bvModal.show("patientPrescribeDetailModal");

                    })
                    .catch((err) => console.log(err));

            },
            // 환자처방 적용
            fn_patient_prescribe_apply(item){

                if(this.fn_chk_medList()){

                //this.isShow.medicine = false;
                this.$bvModal.hide("patientPrescribeDetailModal");

                this.application.prescribe_nm = item.prescribe_nm;
                this.application.prescribe_source = item.prescribe_source;

                this.application.chup_cnt = item.prescribe_pack_cnt;
                this.application.packCnt = item.packs_cnt;
                this.application.packQy = item.pack_capacity;

                axios
                    .post("/api/user/petient/getpatientPrescribeMedicine", item)
                    .then((res) => {
                        console.log("@@@@ 환자처방 사전 res : %o",res);
                        let prescribeList = Object.assign([], this.application.prescribe_medicine);

                        console.log("@@@@ prescribeList : %o",prescribeList);

                        let noStockMed = false; // 입고이력이 없는 재고 체크

                        if(prescribeList == null || prescribeList == [] || prescribeList.length < 1){
                            console.log("@@@@ 처방내역 없는 경우 : "+res.data.patientprescribeMedicineList.length );
                            //처방 약재 정보가 없는 경우
                            for(let i = 0; i < res.data.patientprescribeMedicineList.length; i++){
                                console.log("@@@@ 처방 약재 정보 없음");
                                let medicineInfo = new Object();  
                                
                                medicineInfo.chupCnt = res.data.patientprescribeMedicineList[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.patientprescribeMedicineList[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.patientprescribeMedicineList[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.patientprescribeMedicineList[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.patientprescribeMedicineList[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.patientprescribeMedicineList[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.patientprescribeMedicineList[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.patientprescribeMedicineList[i].org_plce_nm;
                                medicineInfo.product_code = res.data.patientprescribeMedicineList[i].product_code;
                    
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.patientprescribeMedicineList[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = false;

                                // 재고(입고 이력이 없는) 약재 처리
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);  
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }else{
                            
                            
                            for(let i = 0; i < res.data.patientprescribeMedicineList.length; i++){                                
                                let chkDuplication = false;

                                //중복 약재가 있는지 체크 후 CSS 변경처리
                                const duplicationItems = prescribeList.filter(item => item.med_hrb_cd === res.data.patientprescribeMedicineList[i].med_hrb_cd);
                                                                    
                                if(duplicationItems.length > 0){
                                    duplicationItems.forEach(item => {
                                        item.duplication = true;
                                    });

                                    chkDuplication = true;
                                }
                                    
                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.patientprescribeMedicineList[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.patientprescribeMedicineList[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.patientprescribeMedicineList[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.patientprescribeMedicineList[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.patientprescribeMedicineList[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.patientprescribeMedicineList[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.patientprescribeMedicineList[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.patientprescribeMedicineList[i].org_plce_nm;
                                medicineInfo.product_code = res.data.patientprescribeMedicineList[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.patientprescribeMedicineList[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = chkDuplication;

                                // 재고(입고 이력이 없는) 약재 처리
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);
                                
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }

                        this.fn_count_chup_qy();  
                        
                        if(noStockMed){
                            this.fn_move_focus_medcine();
                        }
                    })
                    .catch((err) => console.log(err));
                }
            },
            /***************************************************************
             *  처방전 약재검색 관련 script
             ***************************************************************/
            // 처방전 약재 검색어 검색클릭
            fn_click_medicine_search(){
                if(this.searchMedicineWord.med_hrb_nm == undefined || this.searchMedicineWord.med_hrb_nm == ""){
                    this.medicinesearchBoxShow = false;

                    let msg = "검색할 약재명을 입력해주세요";
                    this.fn_open_alert(msg);
                }else{
                    this.medicinesearchBoxShow = true; //검색어 조회 정보 셀렉트 박스

                    axios
                        .post("/api/user/appliction/searchMedicineWord", this.searchMedicineWord)
                        .then((res) => {
                        //약재검색어 리스트정보
                        this.medicineWordlist = res.data.medicineWordList;

                    })
                    .catch((err) => console.log(err));
                }
            },
            fn_medicine_search_detail(item){
                //this.isShow.mediSearch = true;
                //this.medicineInfo.med_hrb_nm = item.med_hrb_nm;
                //this.medicineInfo.med_prfm = item.med_prfm;

                this.medicineDetailData = item;
                this.$bvModal.show("medicineDetailModal");


            },
            fn_medicine_delete(idx){

                let target = this.application.prescribe_medicine[idx];

                //비방사전 반영으로 들어온 약재는 재고가 있는 경우 삭제 불가 (재고 없는 약재는 삭제 허용)
                if(target.scretDictionaryMed && target.med_sale_prc !== 0){
                    let msg = "비방사전의 약재는 삭제할 수 없습니다.";
                    this.fn_open_alert(msg);
                    return;
                }

                //삭제 약재 코드
                let delete_med_hrb_cd = this.application.prescribe_medicine[idx].med_hrb_cd;

                this.application.prescribe_medicine.splice(idx,1);

                const sameCodeItems = this.application.prescribe_medicine.filter(item => item.med_hrb_cd === delete_med_hrb_cd);

                //1개만 남아 있다면 dup = false
                if (sameCodeItems.length === 1) {
                    sameCodeItems[0].duplication = false;
                }

                this.fn_count_chup_qy();
            },
            /***************************************************************
             *  약재 관련 script
             ***************************************************************/
            // 약재정보 조회
            fn_search_medicine(){

                console.log("@@@@ searchMedicine : %o", this.searchMedicine);

                axios
                    .post("/api/user/appliction/searchMedicine", this.searchMedicine)
                    .then((res) => {
                        console.log("@@@@ 약재정보 res : %o",res);
                        this.medicinelist = res.data.medicineList;

                        console.log("@@@@ medicinelist : %o",this.medicineList);

                        this.searchMedicine.pageInfo.totPage = res.data.totCnt;

                        if(this.searchMedicine.pageInfo.totPage > 0){
                            this.searchMedicine.medicinePageShow = true;
                        }else{
                            this.searchMedicine.medicinePageShow = false;
                        }
                    })
                    .catch((err) => console.log(err));
            },
            //약재정보 상세보기
            fn_show_medicine_detail(item){
                this.medicineDetailData = item;
                this.$bvModal.show("medicineDetailModal");
            },
            //약제정보 반영
            fn_add_medicine(item){

                if(item.med_sale_prc == 0){
                  this.fn_open_alert("재고가 없습니다");
                }else{
                    this.$bvModal.hide("medicineDetailModal");

                    let chkDuplication = false;
                    // 기입력 약재정보 체크
                    for(let i = 0; i < this.application.prescribe_medicine.length; i++){
                        if(item.med_hrb_cd == this.application.prescribe_medicine[i].med_hrb_cd){
                            chkDuplication = true;

                            if(!this.application.prescribe_medicine[i].duplication ){
                                this.application.prescribe_medicine[i].duplication = true;
                            }
                        }
                    }

                    //중복약제가 없는 경우
                    //if(!chkDuplication){

                        //기본입력 처리
                        item.chupCnt = 4.0;
                        item.medicineQy = item.chupCnt * 20;
                        item.totalPrice = item.med_sale_prc * item.medicineQy;
                        item.duplication = chkDuplication;
                        this.application.prescribe_medicine.push(item);

                        this.fn_change_medicineInfo(this.application.prescribe_medicine.length - 1);
                    //}

                    //약재 검색어 초기화
                    this.searchMedicineWord.med_hrb_nm = '';
                    this.medicinesearchBoxShow = false;

                    nextTick(() => {
                        this.$refs.medSearchInfo.focus();
                    })
                }
            },
            fn_grid_select_medicine(index){
                this.gridSelect.medicine = index;
            },
            /***************************************************************
             *  개인방제 관련 script - 
             ***************************************************************/
            // 내처방저장 
            fn_reg_my_application(){    
                if(this.application.prescribe_nm == ''){
                    this.fn_open_alert("처방명을 입력해주세요");
                    return;
                }else if(this.application.prescribe_medicine == null || this.application.prescribe_medicine == []){
                    this.fn_open_alert("처방 약재를 입력해주세요");
                    return;
                }else{

                    let item = {};
                    
                    item.clinic_doctor_id = this.application.clinic_doctor_id;      
                    item.prescribe_nm = this.application.prescribe_nm;
                    item.prescribe_source = this.application.prescribe_source;
                    item.medicinelist = this.application.prescribe_medicine;
                    item.prescribe_category = "";
                    item.prescribe_sub_category = "";
                    item.prescribe_note = "";
                    
                    this.myPrescribeRegData = item;

                    this.$bvModal.show("myPrescribeRegModal");              
                }

            },
            fn_myPrescribe_page_init(){
                this.searchMyPrescribe.pageInfo.page = 1;
            },
            //개인방제 카테고리 변경 - 상세카테고리 갱신
            async fn_myPrescribe_category_change(){
                if(this.searchMyPrescribe.prescribe_category !== ''){
                    const list = await this.getDtlCode('GC00000015', this.searchMyPrescribe.prescribe_category);
                    this.prescrbeMySubCategoryList = list || [];
                }else{
                    this.prescrbeMySubCategoryList = [];
                }

                this.searchMyPrescribe.prescribe_sub_category = '';
                this.fn_myPrescribe_page_init();
            },
            //개인방제 사전조회
            fn_search_myPrescribe(){
                
                //한의사정보 셋팅
                this.searchMyPrescribe.clinic_doctor_id = this.application.clinic_doctor_id;
                console.log("@@@@ searchMyPrescribe : %o", this.searchMyPrescribe);

                axios
                    .post("/api/user/myPrescribe/getMyPrescribeList", this.searchMyPrescribe)
                    .then((res) => {
                        this.myPrescribelist = res.data.myPrescribeList;
                        this.searchMyPrescribe.pageInfo.totPage = res.data.totCnt;

                        if(this.searchMyPrescribe.pageInfo.totPage > 0){
                            this.searchMyPrescribe.myPrescribePageShow = true;                         
                        }else{
                            this.searchMyPrescribe.myPrescribePageShow = false;
                        }  
                        
                    })
                    .catch((err) => console.log(err));
            },
            
            //개인방제사전 페이징처리
            fn_move_myPrescribePage(page){
                this.searchMyPrescribe.pageInfo.page = page;
                this.fn_search_myApplication();
            },            
            fn_myPrescribe_filter(index){
                this.searchMyPrescribe.filterIndex = index;
                this.fn_search_myPrescribe();
            },
            //개인 방제 상세보기
            fn_show_myPrescribe_detail(item,index){
                console.log("@@@@ 개인방제 상세 : %o",item);
                this.gridSelect.selfDictionary = index

                let medicinelist = [];

                axios
                    .post("/api/user/myPrescribe/getMyprescribeMedicine", item)
                    .then((res) => {
                        console.log("@@@@ 개인 방제 상세 res : %o",res);
                        medicinelist = res.data.myPrescribeMedicineList;                        

                        this.myPrescribeInfo.prescribe_nm = item.prescribe_nm;
                        this.myPrescribeInfo.prescribe_source = item.prescribe_source;
                        this.myPrescribeInfo.prescribe_category = item.prescribe_category;
                        this.myPrescribeInfo.prescribe_category_nm = item.prescribe_category_nm;
                        this.myPrescribeInfo.prescribe_note = item.prescribe_note;
                        
                        let medicineInfo = "";
                        console.log("@@@@ medicinelist : %o",medicinelist);

                        for(let i = 0; i < medicinelist.length; i++){
                            if(i == 0){
                                medicineInfo = medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }else{
                                medicineInfo = medicineInfo + "," + medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }
                        }
                        
                        this.myPrescribeInfo.prescribe_medicine = medicineInfo;
                        this.myPrescribeInfo.item = item;
                        
                        this.$bvModal.show("myPrescribeDetailModal");

                    })
                    .catch((err) => console.log(err));

            },
            // 개인방제사전 적용
            fn_myPrescribe_apply(item){

                if(this.fn_chk_medList()){
                //this.isShow.medicine = false;
                this.$bvModal.hide("myPrescribeDetailModal");

                this.application.prescribe_nm = item.prescribe_nm;
                this.application.prescribe_source = item.prescribe_source;

                axios
                    .post("/api/user/myPrescribe/getMyprescribeMedicine", item)
                    .then((res) => {
                        console.log("@@@@ 개인방제 사전 res : %o",res);
                        let prescribeList = Object.assign([], this.application.prescribe_medicine);

                        console.log("@@@@ prescribeList : %o",prescribeList);

                        let noStockMed = false; // 입고이력이 없는 재고 체크

                        if(prescribeList == null || prescribeList == [] || prescribeList.length < 1){
                            console.log("@@@@ 처방내역 없는 경우 : "+res.data.myPrescribeMedicineList.length );
                            //처방 약재 정보가 없는 경우
                            for(let i = 0; i < res.data.myPrescribeMedicineList.length; i++){
                                console.log("@@@@ 처방 약재 정보 없음");
                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.myPrescribeMedicineList[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.myPrescribeMedicineList[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.myPrescribeMedicineList[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.myPrescribeMedicineList[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.myPrescribeMedicineList[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.myPrescribeMedicineList[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.myPrescribeMedicineList[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.myPrescribeMedicineList[i].org_plce_nm;
                                medicineInfo.product_code = res.data.myPrescribeMedicineList[i].product_code;
                    
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.myPrescribeMedicineList[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = false;

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);                                
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }else{
                            
                            
                            for(let i = 0; i < res.data.myPrescribeMedicineList.length; i++){                                
                                //신규 추가여부 체크
                                //let chkAdd = true;
                                let chkDuplication = false;

                                //중복 약재가 있는지 체크 후 CSS 변경처리
                                const duplicationItems = prescribeList.filter(item => item.med_hrb_cd === res.data.myPrescribeMedicineList[i].med_hrb_cd);

                                if(duplicationItems.length > 0){
                                    duplicationItems.forEach(item => {
                                        item.duplication = true;
                                    });

                                    chkDuplication = true;
                                }

                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.myPrescribeMedicineList[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.myPrescribeMedicineList[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.myPrescribeMedicineList[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.myPrescribeMedicineList[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.myPrescribeMedicineList[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.myPrescribeMedicineList[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.myPrescribeMedicineList[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.myPrescribeMedicineList[i].org_plce_nm;
                                medicineInfo.product_code = res.data.myPrescribeMedicineList[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.myPrescribeMedicineList[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = chkDuplication;

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);

                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }

                        this.fn_count_chup_qy();

                        if(noStockMed){
                            this.fn_move_focus_medcine();
                        }
                        
                    })
                    .catch((err) => console.log(err));
                }
            },
            fn_grid_select_myPrescribe(index){
                this.gridSelect.selfDictionary = index;
            },
            /********************************************************
             * 방제사전 조회 - #방제사전
             ********************************************************/
            fn_dictionary_page_init(){
                this.searchDictionary.pageInfo.page = 1;
            },
            // 방재사전 조회 
            fn_search_dictionary(){
                
                console.log("@@@@ searchDictionary : %o", this.searchDictionary);

                axios
                    .post("/api/user/appliction/searchDictionary", this.searchDictionary)
                    .then((res) => {
                        
                        this.dictionarylist = res.data.dictionarylist;
                        this.searchDictionary.pageInfo.totPage = res.data.totCnt;
                        if(this.searchDictionary.pageInfo.totPage > 0){
                            this.searchDictionary.dictionaryPageShow = true;                         
                        }else{
                            this.searchDictionary.dictionaryPageShow = false;
                        }  
                        
                    })
                    .catch((err) => console.log(err));
            },
            fn_move_dictionaryPage(page){
                this.searchDictionary.pageInfo.page = page;
                this.fn_search_dictionary();
            },
            fn_dictionary_filter(index){
                this.searchDictionary.filterIndex = index;
                this.fn_search_dictionary();
            },
            fn_dictionary_detail(item,index){
                this.gridSelect.dictionary = index;
                
                //this.searchDictionary.dictionaryCd = item.dictionaryCd;

                axios
                    .post("/api/user/appliction/dictionarymedicinelist", item)
                    .then((res) => {
                        console.log("@@@@ 방제사전 상세 res : %o",res);
                        let medicinelist = res.data.medicinelist;

                        //dictionaryInfo
                        this.dictionaryInfo.prescribe_nm = item.dictionary_nm;
                        this.dictionaryInfo.prescribe_source = item.dictionary_source;
                        this.dictionaryInfo.dictionary_note1 = item.dictionary_note1;
                        
                        let medicineInfo = "";
                        console.log("@@@@ medicinelist : %o",medicinelist);

                        for(let i = 0; i < medicinelist.length; i++){
                            if(i == 0){
                                medicineInfo = medicinelist[i].med_hrb_nm+" "+medicinelist[i].med_use_qnty;
                            }else{
                                medicineInfo = medicineInfo + "," + medicinelist[i].med_hrb_nm+" "+medicinelist[i].med_use_qnty;
                            }
                        }
                        
                        this.dictionaryInfo.prescribe_medicine = medicineInfo;
                        this.dictionaryInfo.item = item;
                        
                        
                        this.$bvModal.show("dictionaryDetailModal");
                    })
                    .catch((err) => console.log(err));
            },
            // 방제사전 적용
            fn_dictionary_apply(item){
                this.$bvModal.hide("dictionaryDetailModal");
                if(this.fn_chk_medList()){
                //this.isShow.medicine = false;

                console.log("@@@@@ 방제사전 적용 : %o",item);
                this.application.prescribe_nm = item.dictionary_nm;
                this.application.prescribe_source = item.dictionary_source;

                axios
                    .post("/api/user/appliction/dictionarymedicinelist", item)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        let prescribeList = Object.assign([], this.application.prescribe_medicine);

                        console.log("@@@@ prescribeList : %o",prescribeList);

                        let noStockMed = false; // 입고이력이 없는 재고 체크

                        if(prescribeList == null || prescribeList == [] || prescribeList.length < 1){
                            console.log("@@@@ 처방내역 없는 경우 : "+res.data.medicinelist.length );
                            //처방 약재 정보가 없는 경우
                            for(let i = 0; i < res.data.medicinelist.length; i++){                                
                                console.log("@@@@ 처방 약재 정보 없음");

                                //null 인경우 체크 처리
                                if(res.data.medicinelist[i].med_use_qnty == null || res.data.medicinelist[i].med_use_qnty == "" || res.data.medicinelist[i].med_use_qnty == "undefined"){
                                    res.data.medicinelist[i].med_use_qnty = 0;
                                }

                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.medicinelist[i].med_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.medicinelist[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.medicinelist[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.medicinelist[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.medicinelist[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.medicinelist[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.medicinelist[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.medicinelist[i].org_plce_nm;
                                medicineInfo.product_code = res.data.medicinelist[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.medicinelist[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = false;
                                
                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);                                
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }else{
                            
                            
                            for(let i = 0; i < res.data.medicinelist.length; i++){                                

                                let chkDuplication = false;

                                //중복 약재가 있는지 체크 후 CSS 변경처리
                                const duplicationItems = prescribeList.filter(item => item.med_hrb_cd === res.data.medicinelist[i].med_hrb_cd);
                                                                    
                                if(duplicationItems.length > 0){
                                    duplicationItems.forEach(item => {
                                        item.duplication = true;
                                    });

                                    chkDuplication = true;
                                }

                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.medicinelist[i].med_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.medicinelist[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.medicinelist[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.medicinelist[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.medicinelist[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.medicinelist[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.medicinelist[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.medicinelist[i].org_plce_nm;
                                medicineInfo.product_code = res.data.medicinelist[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.medicinelist[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = chkDuplication;

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }

                        this.fn_count_chup_qy();


                        if(noStockMed){
                            this.fn_move_focus_medcine();
                        }
                        
                    })
                    .catch((err) => console.log(err));
                }
            },
            fn_grid_select_dictionary(index){
                this.gridSelect.dictionary = index;
            },
            /********************************************************
             * 비방사전 조회 - #비방사전
             ********************************************************/
            fn_scretDictionary_page_init(){
                this.searchScretDictionary.pageInfo.page = 1;
            },
            //비방사전 카테고리 변경 - 상세카테고리 갱신
            async fn_scretDictionary_category_change(){
                if(this.searchScretDictionary.prescribe_category !== ''){
                    const list = await this.getDtlCode('GC00000015', this.searchScretDictionary.prescribe_category);
                    this.prescrbeScretSubCategoryList = list || [];
                }else{
                    this.prescrbeScretSubCategoryList = [];
                }

                this.searchScretDictionary.prescribe_sub_category = '';
                this.fn_scretDictionary_page_init();
            },
            // 비방사전 조회 
            fn_search_scretDictionary(){
                
                console.log("@@@@ searchScretDictionary : %o", this.searchScretDictionary);

                axios
                    .post("/api/user/appliction/searchScretDictionary", this.searchScretDictionary)
                    .then((res) => {
                        console.log("@@@@ 비방사전 res : %o",res);
                        this.scretDictionarylist = res.data.scetDictionarylist;

                        console.log("@@@@ scretDictionarylist : %o",this.scretDictionarylist);

                        this.searchScretDictionary.pageInfo.totPage = res.data.totCnt;

                        console.log("@@@@ res.data.totCnt : %o",res.data.totCnt);

                        if(this.searchScretDictionary.pageInfo.totPage > 0){
                            this.searchScretDictionary.scretDictionaryPageShow = true;                         
                        }else{
                            this.searchScretDictionary.scretDictionaryPageShow = false;
                        }  
                        
                    })
                    .catch((err) => console.log(err));
            },
            fn_move_scretDictionaryPage(page){
              this.searchScretDictionary.pageInfo.page = page;
              this.fn_search_scretDictionary();
            },
            fn_scretDictionary_filter(index){
                this.searchScretDictionary.filterIndex = index;
                this.fn_search_scretDictionary();
            },
            fn_scretDictionary_detail(item,index){
                this.gridSelect.scretDictionary = index;
                
                //this.searchDictionary.dictionaryCd = item.dictionaryCd;

                axios
                    .post("/api/user/appliction/scretDictionarymedicinelist", item)
                    .then((res) => {
                        console.log("@@@@ 방제사전 상세 res : %o",res);
                        let medicinelist = res.data.medicinelist;

                        //dictionaryInfo
                        this.scretDictionaryInfo.prescribe_nm = item.prescribe_nm;
                        this.scretDictionaryInfo.nick_nm = item.nick_nm;
                        this.scretDictionaryInfo.prescribe_source = item.prescribe_source;
                        this.scretDictionaryInfo.prescribe_category = item.prescribe_category;
                        this.scretDictionaryInfo.prescribe_category_nm = item.prescribe_category_nm;
                        this.scretDictionaryInfo.prescribe_sub_category = item.prescribe_sub_category;
                        this.scretDictionaryInfo.prescribe_sub_category_nm = item.prescribe_sub_category_nm;
                        this.scretDictionaryInfo.indications = item.indications;
                        this.scretDictionaryInfo.secret_prescription_adjust = item.secret_prescription_adjust
                        this.scretDictionaryInfo.usage_criteria_day = item.usage_criteria_day,
                        this.scretDictionaryInfo.usage_criteria_dose = item.usage_criteria_dose,
                        this.scretDictionaryInfo.usage_criteria_pack = item.usage_criteria_pack,
                        this.scretDictionaryInfo.usage_criteria_unit = item.usage_criteria_unit,
                        this.scretDictionaryInfo.remarks = item.remarks

                        let medicineInfo = "";
                        console.log("@@@@ medicinelist : %o",medicinelist);

                        for(let i = 0; i < medicinelist.length; i++){
                            if(i == 0){
                                medicineInfo = medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }else{
                                medicineInfo = medicineInfo + "," + medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }
                        }
                        
                        this.scretDictionaryInfo.prescribe_medicine = medicineInfo;
                        this.scretDictionaryInfo.item = item;

                        this.scretDictionaryInfo.avgStarRate = res.data.avgStarRate;
                        this.scretDictionaryInfo.reviewList = res.data.reviewList;

                        this.$bvModal.show("scretDictionaryDetailModal");
                    })
                    .catch((err) => console.log(err));
            },
            fn_scretDictionary_apply(item){
                this.$bvModal.hide("scretDictionaryDetailModal");
                if(this.fn_chk_medList()){
                //this.isShow.medicine = false;

                console.log("@@@@@ 방제사전 적용 : %o",item);
                this.application.prescribe_nm = item.prescribe_nm;
                this.application.prescribe_source = item.prescribe_source;
                this.application.secret_prescription_seq = item.secret_prescription_seq;
                this.application.secret_clinic_doctor_id = item.clinic_doctor_id;
                this.application.recipe_review_status = 'R';

                axios
                    .post("/api/user/appliction/scretDictionarymedicinelist", item)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        let prescribeList = Object.assign([], this.application.prescribe_medicine);

                        console.log("@@@@ prescribeList : %o",prescribeList);

                        let noStockMed = false; // 입고이력이 없는 재고 체크

                        if(prescribeList == null || prescribeList == [] || prescribeList.length < 1){
                            console.log("@@@@ 처방내역 없는 경우 : "+res.data.medicinelist.length );
                            //처방 약재 정보가 없는 경우
                            for(let i = 0; i < res.data.medicinelist.length; i++){                                
                                console.log("@@@@ 처방 약재 정보 없음");

                                //null 인경우 체크 처리
                                if(res.data.medicinelist[i].med_use_qnty == null || res.data.medicinelist[i].med_use_qnty == "" || res.data.medicinelist[i].med_use_qnty == "undefined"){
                                    res.data.medicinelist[i].med_use_qnty = 0;
                                }

                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.medicinelist[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.medicinelist[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.medicinelist[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.medicinelist[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.medicinelist[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.medicinelist[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.medicinelist[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.medicinelist[i].org_plce_nm;
                                medicineInfo.product_code = res.data.medicinelist[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.medicinelist[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = false;
                                medicineInfo.scretDictionaryMed = true;        //비방사전 반영 약재 여부

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }else{


                            for(let i = 0; i < res.data.medicinelist.length; i++){

                                let chkDuplication = false;
                                //중복 약재가 있는지 체크 후 CSS 변경처리
                                const duplicationItems = prescribeList.filter(item => item.med_hrb_cd === res.data.medicinelist[i].med_hrb_cd);

                                if(duplicationItems.length > 0){
                                    duplicationItems.forEach(item => {
                                        item.duplication = true;
                                    });

                                    chkDuplication = true;
                                }

                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.medicinelist[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.medicinelist[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.medicinelist[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.medicinelist[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.medicinelist[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.medicinelist[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.medicinelist[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.medicinelist[i].org_plce_nm;
                                medicineInfo.product_code = res.data.medicinelist[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.medicinelist[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = chkDuplication;
                                medicineInfo.scretDictionaryMed = true;        //비방사전 반영 약재 여부

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);

                            }

                        }

                        this.fn_count_chup_qy();

                        if(noStockMed){
                            this.fn_move_focus_medcine();
                        }

                    })
                    .catch((err) => console.log(err));
                }
            },

            /********************************************************
             * 이전처방 조회 - #이전처방
             ********************************************************/
            //날짜변경시 페이지 변환
            fn_page_init(){
                this.searchPrePrescribe.pageInfo.page = 1;
            },
            //이전처방 조회
            fn_search_prePrescribe(){

                //한의사정보 셋팅
                this.searchPrePrescribe.clinic_doctor_id = this.application.clinic_doctor_id;
                console.log("@@@@ searchPrePrescribe : %o", this.searchPrePrescribe);

                axios
                    .post("/api/user/appliction/searchPrePrescribe", this.searchPrePrescribe)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.prePrescribelist = res.data.prePrescribelist;

                        console.log("@@@@ prePrescribelist  : %o",this.prePrescribelist );

                        this.searchPrePrescribe.pageInfo.totPage = res.data.totCnt;

                        if(this.searchPrePrescribe.pageInfo.totPage > 0){
                            this.searchPrePrescribe.prePrescribePageShow = true;
                        }else{
                            this.searchPrePrescribe.prePrescribePageShow = false;
                        }

                    })
                    .catch((err) => console.log(err));
            },
            fn_move_prePrescribePage(page){
                this.searchPrePrescribe.pageInfo.page = page;
                this.fn_search_prePrescribe();
            },
            fn_prePrescribe_filter(index){
                this.searchPrePrescribe.filterIndex = index;
                this.fn_search_prePrescribe();
            },
            fn_prePrescribe_detail(item,index){

                this.gridSelect.beforeReceipt = index;

                axios
                    .post("/api/user/appliction/prePrescribeMedicinelist", item)
                    .then((res) => {
                       console.log("@@@@ 이전내역 상세 res : %o",res);

                       let medicinelist = res.data.prePrescribeMedicinelist;

                        //prePrescribeInfo
                        this.prePrescribeInfo.prescribe_nm = item.prescribe_nm;
                        this.prePrescribeInfo.prescribe_source = item.prescribe_source;

                        let medicineInfo = "";

                        for(let i = 0; i < medicinelist.length; i++){
                            if(i == 0){
                                medicineInfo = medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }else{
                                medicineInfo = medicineInfo + "," + medicinelist[i].med_hrb_nm+" "+medicinelist[i].medicine_use_qnty;
                            }
                        }

                        this.prePrescribeInfo.prescribe_medicine = medicineInfo;
                        this.prePrescribeInfo.item = item;

                         this.$bvModal.show("prePrescribeDetailModal");

                    })
                    .catch((err) => console.log(err));

            },

            // 이전처방 적용
            fn_prePrescribe_apply(item){

                if(this.fn_chk_medList()){
                axios
                    .post("/api/user/appliction/prePrescribeMedicinelist", item)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        let prescribeList = Object.assign([], this.application.prescribe_medicine);

                        console.log("@@@@ prescribeList : %o",prescribeList);

                        let noStockMed = false; // 입고이력이 없는 재고 체크

                        if(prescribeList == null || prescribeList == [] || prescribeList.length < 1){
                            console.log("@@@@ 처방내역 없는 경우 : "+res.data.prePrescribeMedicinelist.length );
                            //처방 약재 정보가 없는 경우
                            for(let i = 0; i < res.data.prePrescribeMedicinelist.length; i++){
                                console.log("@@@@ 처방 약재 정보 없음");
                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.prePrescribeMedicinelist[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.prePrescribeMedicinelist[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.prePrescribeMedicinelist[i].med_hrb_nm;
                                medicineInfo.med_hrb_dtl_seq = res.data.prePrescribeMedicinelist[i].med_hrb_dtl_seq;
                                medicineInfo.med_prfm = res.data.prePrescribeMedicinelist[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.prePrescribeMedicinelist[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.prePrescribeMedicinelist[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.prePrescribeMedicinelist[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.prePrescribeMedicinelist[i].org_plce_nm;
                                medicineInfo.product_code = res.data.prePrescribeMedicinelist[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.prePrescribeMedicinelist[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = false;

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);
                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }else{


                            for(let i = 0; i < res.data.prePrescribeMedicinelist.length; i++){

                                let chkDuplication = false;
                                //중복 약재가 있는지 체크 후 CSS 변경처리
                                const duplicationItems = prescribeList.filter(item => item.med_hrb_cd === res.data.prePrescribeMedicinelist[i].med_hrb_cd);

                                if(duplicationItems.length > 0){
                                    duplicationItems.forEach(item => {
                                        item.duplication = true;
                                    });

                                    chkDuplication = true;
                                }

                                //console.log("@@@@ 약재 중복없음");
                                //같은 약재가 존재하지 않는 경우 추가
                                let medicineInfo = new Object();
                                medicineInfo.chupCnt = res.data.prePrescribeMedicinelist[i].medicine_use_qnty;
                                medicineInfo.med_hrb_cd = res.data.prePrescribeMedicinelist[i].med_hrb_cd;
                                medicineInfo.med_hrb_nm = res.data.prePrescribeMedicinelist[i].med_hrb_nm;
                                medicineInfo.med_prfm = res.data.prePrescribeMedicinelist[i].med_prfm;
                                medicineInfo.med_sale_prc = res.data.prePrescribeMedicinelist[i].med_sale_prc;
                                medicineInfo.company_cd = res.data.prePrescribeMedicinelist[i].company_cd;
                                medicineInfo.org_plce_cd = res.data.prePrescribeMedicinelist[i].org_plce_cd;
                                medicineInfo.org_plce_nm = res.data.prePrescribeMedicinelist[i].org_plce_nm;
                                medicineInfo.product_code = res.data.prePrescribeMedicinelist[i].product_code;
                                medicineInfo.medicineQy = Math.round(medicineInfo.chupCnt * this.application.chup_cnt);
                                medicineInfo.totalPrice = Math.round(res.data.prePrescribeMedicinelist[i].med_sale_prc * medicineInfo.medicineQy);
                                medicineInfo.duplication = chkDuplication;

                                // 재고(입고이력이 없는) 약재 체크
                                if(medicineInfo.med_sale_prc == 0){
                                    noStockMed = true;
                                }

                                this.application.prescribe_medicine.push(medicineInfo);

                            }

                            console.log("@@@@ application.prescribe_medicine :  %o" , this.application.prescribe_medicine);
                        }

                        this.fn_count_chup_qy();

                        if(noStockMed){
                            this.fn_move_focus_medcine();
                        }
                        
                    })
                    .catch((err) => console.log(err));
                }
            },
            fn_grid_select_beforeReceipt(index){
                this.gridSelect.beforeReceipt = index;
            },

            // 파우치 정보 가져오기
            async fn_search_pouchImg(){
                await axios
                    .post("/api/user/appliction/searchPouchImg")
                    .then((res) => {
                        this.pouchImgList = res.data.pouchImgList;
                        console.log("@@@@ fn_search_pouchImg : %o",this.pouchImgList);
                        this.application.pouchImgInfo = this.pouchImgList[0];

                    })
                    .catch((err) => console.log(err));
            },
            // 포장 정보 가져오기
            async fn_search_wrapperImg(){
              await axios
                    .post("/api/user/appliction/searchWrapperImg")
                    .then((res) => {

                        this.wrapperImgList = res.data.wrapperImgList;

                        console.log("@@@@ fn_search_wrapperImg : %o",this.wrapperImgList);

                        this.application.wrapperImgInfo = this.wrapperImgList[0];

                    })
                    .catch((err) => console.log(err));
            },
          async fn_search_boxImg(){
              await axios
                    .post("/api/user/appliction/searchBoxImg")
                    .then((res) => {
                        this.boxImgList = res.data.boxImgList;

                      console.log("@@@@ fn_search_boxImg : %o",res.data.boxImgList);
                        this.application.boxImgInfo = this.boxImgList[0];

                    })
                    .catch((err) => console.log(err));
            },
            /************************************************************************
             * 발송
             ************************************************************************/ 
            fn_change_delivery_type(){

                this.application.total_delivery_price = 4000;

                if(this.application.deliveryType == "TTC"){
                    this.application.send_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.send_tel_num = this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    //this.application.send_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.send_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.send_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.send_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    this.application.receive_nm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
                    this.application.receive_tel_num = this.$store.getters['clinicDoctorInfo/getDoctorTelNum'];
                    this.application.receive_phone_num = this.$store.getters['clinicDoctorInfo/getDoctorPhoneNum'];
                    this.application.receive_post_no= this.$store.getters['clinicDoctorInfo/getClinicPostNo'];
                    this.application.receive_addr = this.$store.getters['clinicDoctorInfo/getClinicAddr'];
                    this.application.receive_addr_dtl = this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'];

                }else if(this.application.deliveryType == "CTP"){
                    //의사명에서 한의원 명으로 변경 (20260117)
                    //의사전화번호에서 한의원 전화번호로 변경 (20260129)
                    this.application.send_nm = this.$store.getters['clinicDoctorInfo/getClinicNm'];
                    this.application.send_tel_num= this.$store.getters['clinicDoctorInfo/getClinicTelNum'];
                    //this.application.send_phone_num= this.$store.getters['clinicDoctorInfo/getDoctorPhoneNum'];
                    this.application.send_post_no = this.$store.getters['clinicDoctorInfo/getClinicPostNo'];
                    this.application.send_addr = this.$store.getters['clinicDoctorInfo/getClinicAddr'];
                    this.application.send_addr_dtl = this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'];

                    this.application.receive_nm = this.selectPetientInfo.patient_nm;
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = this.selectPetientInfo.patient_tel_num;
                    this.application.receive_post_no = this.selectPetientInfo.patient_post_no;
                    this.application.receive_addr = this.selectPetientInfo.patient_addr;
                    this.application.receive_addr_dtl = this.selectPetientInfo.patient_addr_dtl;
                }else if(this.application.deliveryType == "TTP"){
                    this.application.send_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.send_tel_num = this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    //this.application.send_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.send_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.send_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.send_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    this.application.receive_nm = this.selectPetientInfo.patient_nm;
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = this.selectPetientInfo.patient_tel_num;
                    this.application.receive_post_no = this.selectPetientInfo.patient_post_no;
                    this.application.receive_addr = this.selectPetientInfo.patient_addr;
                    this.application.receive_addr_dtl = this.selectPetientInfo.patient_addr_dtl;
                }else if(this.application.deliveryType == "TTT"){
                    this.application.send_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.send_tel_num = this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    //this.application.send_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.send_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.send_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.send_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    this.application.receive_nm = this.$store.getters['tangjunInfo/getTangjunNm'];
                    this.application.receive_tel_num =  this.$store.getters['tangjunInfo/getTangjunTelNum'];
                    this.application.receive_phone_num = this.$store.getters['tangjunInfo/getTangjunPhoneNum'];
                    this.application.receive_post_no = this.$store.getters['tangjunInfo/getTangjunPost'];
                    this.application.receive_addr = this.$store.getters['tangjunInfo/getTangjunAddr'];
                    this.application.receive_addr_dtl = this.$store.getters['tangjunInfo/getTangjunAddrDtl'];

                    //배송비 차감
                    this.application.total_delivery_price = 0;
                }else {
                    this.application.send_nm = "";
                    this.application.send_tel_num= "";
                    this.application.send_phone_num= "";
                    this.application.send_post_no = "";
                    this.application.send_addr = "";
                    this.application.send_addr_dtl = "";

                    this.application.receive_nm = ""; 
                    this.application.receive_tel_num = "";
                    this.application.receive_phone_num = "";
                    this.application.receive_post_no = "";
                    this.application.receive_addr = "";
                    this.application.receive_addr_dtl = "";
                }
            },
            //다음주소 정보 가져오기
            callBackAddr(call,postInfo){
                
                if(call == "send"){
                    this.application.send_post_no = postInfo.zonecode;
                    this.application.send_addr = postInfo.roadAddress;
                    this.application.send_addrDtl = "";    
                }else if(call == "recive"){
                    this.application.receive_post_no = postInfo.zonecode;
                    this.application.receive_addr = postInfo.roadAddress;
                    this.application.receive_addr_dtl = "";
                }                
            },
            /**********************************************************
             * 탕제신청 확인
             **********************************************************/    
            fn_medicineList_info(){
                let medicineInfo = "";

                for(let i = 0; i < this.application.prescribe_medicine.length; i++){
                    if(i == 0){
                        medicineInfo = this.application.prescribe_medicine[i].med_hrb_nm+" "+this.application.prescribe_medicine[i].chupCnt;
                    }else{
                        medicineInfo = medicineInfo + "," + this.application.prescribe_medicine[i].med_hrb_nm+" "+this.application.prescribe_medicine[i].chupCnt;
                    }
                }

                //console.log("@@@@@@@@@@@@탕제신청확인 약제정보 111: "+medicineInfo);

                this.med_list = medicineInfo;                
            },

            /**********************************************************
             * 복용법
             **********************************************************/ 
            fn_click_upload(){
                
                this.init_howTake();
                this.howTake[0].selected = 'file';
                let fileInputElement = this.$refs.howTakeFile;
                fileInputElement.click();
            },

            onChangeLabel (evt, row, idx) {

                if(this.howTake[0].selected != 'format'){
                    //전용서식이 아닌경우 모든 버튼 disable
                    if(idx == 0){
                        this.init_howTake();
                    }
                }else{

                    //전용서식이 경우 모든 버튼 disable 해제
                    for(let i = 1; i < this.howTake.length; i++){
                        for(let j = 0; j < this.howTake[i].data.length; j++){
                            this.howTake[i].data[j].disabled = false;
                        }
                    }

                    // 파일 정보 초기화
                    this.upLoadFile.upFile = '';
                    this.application.howTakeFileNm = '';


                }

                // 금지 음식물 선택시 
                if (typeof evt === 'object') { 
                    
                    let itemMap = row.data.reduce((map, item) => {
                        map[item.value] = item.text
                        return map
                    }, {})

                    let selectedTexts = evt.map(value => { 
                            return itemMap[value];    
                    })


                    //기타가 포함되어 있지 않으면 기타값 초기화
                    if(!selectedTexts.includes('기타')){
                        this.howTake[idx].etcMsg = '';
                    }
                    //기타 제거 처리
                    selectedTexts = selectedTexts.filter((value) => value !== '기타');
                    this.howTake[idx].label = selectedTexts.join();

                    
                } else {
                    // 기타를 눌렀을 경우
                    if (evt === 'etc') row.etcMsg = ''
                    const filteredData = row.data.filter(item => item.value === evt)
                    this.howTake[idx].label = Object.assign(...filteredData).text
                }


            },

            //복용법 초기화
            init_howTake(){
                for(let i = 1; i < this.howTake.length; i++){
                            
                    this.howTake[i].selected = '';

                    //금지음식인 경우 초기화가 다름
                    if( i == 4){
                        this.howTake[i].selected = [];
                    }else{
                        this.howTake[i].selected = '';    
                    }

                    this.howTake[i].label = '';
                    this.howTake[i].etcMsg = '';

                    //복용법 선택 diasbled
                    for(let j = 0; j < this.howTake[i].data.length; j++){
                        this.howTake[i].data[j].disabled = true
                    }                    
                }
            },    

            // 기타 선택시 처리
            isEtcSelected(item) {
                if (item.mode === 'select') {
                    return item.selected.includes('etc');
                }

                return item.selected === 'etc';
            },
            
            // 복용법 파일 변경여부 체크
            fn_fileHowTakeChange(e){
                
                this.upLoadFile.upFile = e.target.files[0];
                this.application.howTakeFileNm = this.upLoadFile.upFile.name;
            },

            fn_move_delivery(){

               console.log("@@@@@@@ this.howTake[0].selected  : %o",this.howTake[0].selected );
                console.log("@@@@@@@ this.application.howTakeFileNm : %o",this.application.howTakeFileNm);
                console.log("@@@@@@@ this.upLoadFile.upFile : %o",this.upLoadFile.upFile);

                //파일 다운로드인데 파일 정보가 없는 경우
                if(this.howTake[0].selected === 'file'){
                  if(this.application.howTakeFileNm === '' && this.upLoadFile.upFile === ''){
                    this.fn_open_alert("파일 정보가 없습니다");
                    return;
                  }
                }

                this.currentMenu = 2;                    

                
                this.application.howtake_type = this.howTake[0].selected;

                if(this.application.howtake_type == 'format'){
                    this.application.howtake_count = this.howTake[1].selected;
                    this.application.howtake_time = this.howTake[2].selected;
                    this.application.howtake_temperature = this.howTake[3].selected;
                    this.application.howtake_forbidden = this.howTake[4].selected;

                    this.application.howtake_count_etc = this.howTake[1].etcMsg;
                    this.application.howtake_time_etc = this.howTake[2].etcMsg;
                    this.application.howtake_forbidden_etc = this.howTake[4].etcMsg;
                }    
            },
            //복용법 파일 삭제
            fn_howtake_file_delete(){
                this.application.howTakeFileNm = '';
                this.application.howtake_file_id = '';
                this.howTake[0].selected = '';
                this.upLoadFile.upFile = '';
            },
            onScroll() {
                console.log("스크롤 스크롤...");
            },
            // alert 처리
            fn_alert_close(type){
                
                console.log("@@@@ type : "+type);
                 this.initAlertShow = false;  

                if(type == 'ok'){
                    if(this.initInfo == "patient"){
                        this.isUserSelect = false           //환자선택여부
                        //this.isShow.patient = false         //환자검색
                        this.isDetail = false
                        this.gridSelect.patient = null
                        this.gridSelect.patientPrescribe = null
                        this.tabIndices.patient = 2

                        this.selectPetientInfo = {};

                        //처방내역정보 초기화
                        this.patientPrescribeList = [];
                        this.searchPatientPrescribe.patient_seq = '';
                        this.searchPatientPrescribe.pageInfo.totPage = 0;
                        this.searchPatientPrescribe.pageInfo.page = 1;
                        this.searchPatientPrescribe.patientPrescribeShow = false;
                    }else if(this.initInfo == "medicine"){
                        this.isShow.mediSearch = false;
                        this.isShow.totalParice = false;
                        this.application.prescribe_nm = "";
                        this.application.prescribe_source = "";
                        this.application.prescribe_medicine = [];
                        this.application.recipe_review_status = 'N'
                        this.application.secret_prescription_seq = '';     //비방사전 적용 뱃지/합방제한 초기화
                        this.application.secret_clinic_doctor_id = '';

                        this.application.sum_chup_qy = 0;
                        this.application.total_medicin_qy = 0;
                        this.application.total_price = 0;
                    }else if(this.initInfo == "receiveInfo"){
                        this.fn_reg_appication();
                    }
                }
            },
            //재처방 요청처리
            fn_represcribe(rePresciptSeq){
                console.log("@@@@@ 재처방 요청 :"+rePresciptSeq);

                let param = new Object();
                param.rePresciptSeq = rePresciptSeq;

                axios
                    .post("/api/user/appliction/selectRePrescipt", param)
                    .then((res) => {

                        console.log("@@@@@ 재처방 요청 : %o",res.data);

                        this.application.patient_seq = res.data.patientInfo.patient_seq;            //환자코드
                        this.application.patient_name =  res.data.patientInfo.patient_nm;            //환자명

                        //환자처방내역 조회호출
                        this.searchPatientPrescribe.patient_seq = res.data.patientInfo.patient_seq;
                        this.searchPatientPrescribe.clinic_doctor_id = this.application.clinic_doctor_id;
                        this.fn_search_patient_prescribe();

                        this.application.prescribe_note = res.data.presciptInfo.prescribe_note;     //처방메모
                        this.application.prescribe_nm = res.data.presciptInfo.prescribe_nm;         //처방명
                        this.application.prescribe_source = res.data.presciptInfo.prescribe_nm;     //출전명
                        
                        this.application.ny_ampul = res.data.presciptInfo.ny_ampul;              //녹용앰플여부
                        this.application.jhg = res.data.presciptInfo.jhg;                   //자하거여부
                        this.application.sweetener = res.data.presciptInfo.sweetener;                 //감미제사용량
                        this.application.sweet_flavor = res.data.presciptInfo.sweet_flavor;                //향기첨가

                        
                        this.application.chup_cnt = res.data.presciptInfo.prescribe_pack_cnt;                  //첩수
                        
                        this.application.packQy = res.data.presciptInfo.pack_capacity;                  //팩용량   
                        this.application.pressureYn = res.data.presciptInfo.pressure_yn;            //압력여부                           
                        this.application.packCnt = res.data.presciptInfo.packs_cnt;                   //팩수
                        
                        this.application.mark_yn = res.data.presciptInfo.mark_yn;                  //마킹여부

                        // 파우치 선택
                        const pouchIdx = this.pouchImgList.findIndex(item => item.wrapper_file_id === res.data.presciptInfo.pouch_img_file_id);
                        const pouchIndex = pouchIdx !== -1 ? pouchIdx : 0;
                        this.selectPouchImgIdx = pouchIndex;
                        this.application.pouchImgInfo = this.pouchImgList[pouchIndex];

                        // 포장방식 선택
                        const wrapperIdx = this.wrapperImgList.findIndex(item => item.wrapper_file_id === res.data.presciptInfo.wrapper_type_img_file_id);
                        const wrapperIndex = wrapperIdx !== -1 ? wrapperIdx : 0;
                        this.selectWrapperImgIdx = wrapperIndex;
                        this.application.wrapperImgInfo = this.wrapperImgList[wrapperIndex];

                        // 박스 선택
                        const boxIdx = this.boxImgList.findIndex(item => item.wrapper_file_id === res.data.presciptInfo.box_img_file_id);
                        const boxIndex = boxIdx !== -1 ? boxIdx : 0;
                        this.selectBoxImgIdx = boxIndex;
                        this.application.boxImgInfo = this.boxImgList[boxIndex];

                        this.fn_product_count();

                        this.application.instructions = res.data.presciptInfo.prepare_order;         //조제지시
                        this.application.takeMedicine = res.data.presciptInfo.take_way;              //약복용방법
                        this.application.deliveryType = res.data.presciptInfo.delivery_type;         //배송방법 
                         
                        this.application.deliveryMemo = res.data.presciptInfo.delivery_memo;         //배송메모
                        this.application.wrapperReq = res.data.presciptInfo.wrapper_req;             //포장요구사항

                        //복약지도서 medication guide
                        if(res.data.howTakeInfo != null){

                          console.log("@@@@@ howTakeInfo : %o",res.data.howTakeInfo);

                            //전용 서식정보가 있는 경우
                            if(res.data.howTakeInfo.howtake_type === 'format'){

                                this.howTake[0].selected = res.data.howTakeInfo.howtake_type;
                                const labelData = this.howTake[0].data.filter(item => item.value === res.data.howTakeInfo.howtake_type)
                                this.howTake[0].label = Object.assign(...labelData).text

                                this.application.howtake_type = res.data.howTakeInfo.howtake_type;

                                this.howTake.slice(1).forEach(item => {
                                    if (item && item.data) {
                                        item.data.forEach(row => {
                                        row.disabled = false;
                                        });
                                    }
                                });

                                if(res.data.howTakeInfo.howtake_count != null && res.data.howTakeInfo.howtake_count !== ''){
                                  this.application.howtake_count = res.data.howTakeInfo.howtake_count;
                                  this.howTake[1].selected = res.data.howTakeInfo.howtake_count;

                                  const filteredData = this.howTake[1].data.filter(item => item.value === res.data.howTakeInfo.howtake_count)
                                  this.howTake[1].label = Object.assign(...filteredData).text

                                  this.application.howtake_count_etc = res.data.howTakeInfo.howtake_count_etc;
                                  this.howTake[1].etcMsg = res.data.howTakeInfo.howtake_count_etc;
                                }

                                if(res.data.howTakeInfo.howtake_time != null && res.data.howTakeInfo.howtake_time !== '') {
                                  this.application.howtake_time = res.data.howTakeInfo.howtake_time;
                                  this.howTake[2].selected = res.data.howTakeInfo.howtake_time;

                                  const filteredData2 = this.howTake[2].data.filter(item => item.value === res.data.howTakeInfo.howtake_time)
                                  this.howTake[2].label = Object.assign(...filteredData2).text

                                  this.application.howtake_time_etc = res.data.howTakeInfo.howtake_time_etc;
                                  this.howTake[2].etcMsg = res.data.howTakeInfo.howtake_time_etc;
                                }

                                if(res.data.howTakeInfo.howtake_temperature != null && res.data.howTakeInfo.howtake_temperature !== '') {
                                  this.application.howtake_temperature = res.data.howTakeInfo.howtake_temperature;
                                  this.howTake[3].selected = res.data.howTakeInfo.howtake_temperature;

                                  const filteredData3 = this.howTake[3].data.filter(item => item.value === res.data.howTakeInfo.howtake_temperature)
                                  this.howTake[3].label = Object.assign(...filteredData3).text
                                }

                                //howtake_forbidden : [],
                                this.application.howtake_forbidden = res.data.howTakeInfo.howtake_forbidden;

                                //체크처리를 위한 list 처리
                                const forbiddenStr = res.data.howTakeInfo.howtake_forbidden

                                const forbiddenList = forbiddenStr
                                ? forbiddenStr.split(',').map(v => v.trim()).filter(Boolean)
                                : []

                                if(res.data.howTakeInfo.howtake_forbidden_etc != ''){
                                    forbiddenList.push('etc');
                                }

                                this.howTake[4].selected = forbiddenList;

                                const itemMap = (this.howTake[4].data || []).reduce((map, item) => {
                                    map[item.value] = item.text
                                    return map
                                }, {})

                                let selectedTexts = forbiddenList.map(value => { 
                                return itemMap[value];    
                                })

                                //기타 제거 처리
                                selectedTexts = selectedTexts.filter((value) => value !== '기타');
                                this.howTake[4].label = selectedTexts.join();

                                this.application.howtake_forbidden_etc = res.data.howTakeInfo.howtake_forbidden_etc;
                                this.howTake[4].etcMsg = res.data.howTakeInfo.howtake_forbidden_etc;


                            }if(res.data.howTakeInfo.howtake_type == 'file'){
                                this.application.howtake_type = res.data.howTakeInfo.howtake_type;
                                this.howTake[0].selected = res.data.howTakeInfo.howtake_type;
                                this.application.howtake_file_id = res.data.howTakeInfo.howtake_file_id;              // 복용법 파일ID
                                this.application.howTakeFileNm = res.data.howTakeInfo.file_org_name;                // 복용법 파일
                            }
                        }

                        //recipe_review_status : 'N'
                        console.log("@@@@@ 환자정보 처리");
                        //환자정보 처리
                        this.selectPetientInfo.patient_chart_no = res.data.patientInfo.patient_chart_no;
                        this.selectPetientInfo.patient_nm = res.data.patientInfo.patient_nm;
                        this.selectPetientInfo.patient_gender_nm = res.data.patientInfo.patient_gender_nm;
                        this.selectPetientInfo.patient_age = res.data.patientInfo.patient_age;
                        this.selectPetientInfo.last_prescribe_dt = res.data.patientInfo.last_prescribe_dt;
                        this.selectPetientInfo.patient_tel_num = res.data.patientInfo.patient_tel_num;
                        this.selectPetientInfo.patient_post_no = res.data.patientInfo.patient_post_no;
                        this.selectPetientInfo.patient_addr = res.data.patientInfo.patient_addr;
                        this.selectPetientInfo.patient_addr_dtl = res.data.patientInfo.patient_addr_dtl;

                        // 환자정보 Tab 처리
                        this.tabIndices.patient = 0;
                        // 환자 선택 여부
                        this.isUserSelect = true;
                        //화면에 뿌리는 문구
                        this.patientViewInfo = res.data.patientInfo.patient_nm + '('+res.data.patientInfo.patient_gender_nm+'/'+res.data.patientInfo.patient_age+') '+res.data.patientInfo.patient_chart_no;

                      console.log("@@@@@ 액재처리");
                        //약재처리
                        res.data.medicienList.forEach(item => {
                            item.chupCnt = item.medicine_use_qnty;
                            item.medicineQy = Math.round(item.medicine_use_qnty * this.application.chup_cnt);
                            item.totalPrice = Math.round(item.med_sale_prc * item.medicineQy);
                        })
                        this.application.prescribe_medicine = res.data.medicienList;                                 //처방약제
                        this.fn_count_chup_qy();  //약재 합계 처리

                        //비방사용여부 처리
                        this.application.secret_prescription_seq = res.data.presciptInfo.secret_prescription_seq;
                        this.application.secret_clinic_doctor_id = res.data.presciptInfo.secret_clinic_doctor_id;


                        let param = new Object();
                        param.secret_prescription_seq = this.application.secret_prescription_seq;
                        param.clinic_doctor_id = this.application.secret_clinic_doctor_id;

                        //비방사전 약재 정보 조회해오기
                        axios
                          .post("/api/user/appliction/scretDictionarymedicinelist", param)
                          .then((res) => {
                            console.log("@@@@ 방제사전 상세 res : %o",res);
                            let scretMedicinelist = res.data.medicinelist;

                            //처방약제 중 비방사전에 있는 약재는 삭제 불가하도록 표시 처리
                            this.application.prescribe_medicine.forEach(medItem => {
                                const isScretMed = scretMedicinelist.some(scretItem => scretItem.med_hrb_cd === medItem.med_hrb_cd);
                                if(isScretMed){
                                    medItem.scretDictionaryMed = true;        //비방사전 반영 약재 여부
                                }
                            });

                          });
                        
                    })
                    .catch((err) => console.log(err));

            } 
        },
        data () {
            return {
                leftArea : 0,
                viewPositionX: 0,
                tranformPx : 0,
                div_hight : 0,
                clinicDoctorClass : '',
                pouchOffset: 0,
                wrapperOffset: 0,
                boxOffset: 0,
                application : {
                    prescribe_type : 'T',           //처방분류
                    prescribe_type_nm : '탕전',     //처방분류명

                    clinic_doctor_id : '',          //한의원 한의사ID
                    doctor_nm : '',                 //의사명
                    clinic_nm : '',                 //처방기관
                    clinic_tel : '',                //처방기관
                    clinic_addr : '',               //처방기관
                    clinic_addr_detail : '',        //처방기관
                    
                    patient_seq : '',               //환자SEQ
                    patient_name : '',               //환자명
                    prescribe_note : '',            //처방메모
                    prescribe_nm : '',              //처방명
                    prescribe_source : '',          //출전명
                    prescribe_medicine : [],        //처방약제
                    secret_prescription_seq : '',   //비방사전 반영 SEQ (비방사전 적용여부 판단)
                    secret_clinic_doctor_id : '',   //비방사전 등록자 한의사ID
                    
                    ny_ampul : '0',              //녹용앰플여부
                    jhg : '0',                   //자하거여부
                    sweetener : '0',                 //감미제사용량
                    sweet_flavor : '',                //향기첨가

                    
                    chup_cnt : 20,                  //첩수
                    sum_chup_qy : 0,                //첩량합
                    total_medicin_qy : 0,           //총약재량
                    
                    total_med_price : 0,            //총약재비용
                    total_prepare_price : 0,        //총조제비용
                    total_product_price : 0,        //총제품비용
                    total_etc_price : 0,            //총기타비용
                    total_delivery_price : 4000,       //총배송비용
                    total_tangjeon_price : 12000,       //총탕전비용
                    total_price : 0,                //총가격
                    
                    etcText : "",                   //기타비용내역

                    packQy : 100,                  //팩용량   
                    pressureYn : 'N',                //압력여부                           
                    packCnt : 30,                   //팩수
                    
                    mark_yn : 'Y',                  //마킹여부
                    pouchImgInfo : {},              //선택된 파우치이미지
                    wrapperImgInfo : {},            //선택된 포장방식이미지
                    boxImgInfo : {},                //선택된 박스이미지                    
                    instructions : '',              //조제지시
                    takeMedicine : '',              //약복용방법
                    deliveryType : 'CTP',           //배송방법 
                    send_nm : "",                   //보내는 사람명
                    send_tel_num: "",               //보내는 사람 전화번호
                    send_phone_num: "",             //보내는 사람 핸드폰 번호
                    send_post_no : "",              //보내는 사람 우편번호
                    send_addr : "",                 //보내는 사람 주소
                    send_addrDtl : "",              //보내는 사람 주소상세
                    receive_nm : "",                //받는 사람 명
                    receive_tel_num : "",           //받는 사람 전화번호
                    receive_phone_num : "",         //받는 사람 핸드폰번호
                    receive_post_no: "",            //받는 사람 우편번호
                    receive_addr : "",              //받는 사람 주소
                    receive_addr_dtl : "",           //받는 사람 주소상세   
                    deliveryMemo : '',              //배송메모
                    wrapperReq : '',                //포장요구사항

                    //복약지도서 medication guide
                    howtake_type : '',
                    howtake_count : '',
                    howtake_count_etc : '',
                    howtake_time : '',
                    howtake_time_etc : '',
                    howtake_temperature : '',
                    howtake_forbidden : [],
                    howtake_forbidden_etc : '',

                    howtake_file_id : '',             // 복용법 파일ID
                    howTakeFileNm : '',             // 복용법 파일
                    howTake_clinic_name: this.$store.getters['clinicDoctorInfo/getClinicNm'] ,
                    howTake_clinic_tel: this.$store.getters['clinicDoctorInfo/getClinicTelNum'],
                    howTake_clinic_address: this.$store.getters['clinicDoctorInfo/getClinicAddr']+' '+this.$store.getters['clinicDoctorInfo/getClinicAddrDtl'],

                    recipe_review_status : 'N'

                },
                //처방 약재 목록
                med_list : '',
                
                //복용법 파일
                upLoadFile : {
                    upFile : ''
                },

                //환자검색 데이터
                searchPatient : {
                    searchClinicDoctorId : '',
                    searchPatientNm : '',
                    pageInfo : {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    },
                    PatientPageShow : false                    
                },
                patientViewInfo : '',          //화면표출문구
                selectPetientInfo :{},     //선택된 환자정보
                packlist : [],             //팩수   
                patientList : [],          //환자리스트 
                packCount : [],               
                
                //환자처방 조회 페이징
                searchPatientPrescribe : {
                   patient_seq : '',
                   prescribe_type : '',
                   clinic_doctor_id : '',
                   pageInfo : {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    },
                    patientPrescribeShow : false 
                },
                patientPrescribeList : [], //환자처방내역리스트

                patientPrescribeInfo : {            //환자처방상세
                    prescribe_nm : '',    
                    prescribe_source : '',
                    prescribe_medicine : '',
                    item : {}
                },
                
                searchMedicine : {          //약재탭 검색정보
                    med_hrb_nm : '',
                    pageInfo : {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    },
                    medicinePageShow : false
                },
                medicinelist : [],          //약재리스트
                medicineInfo : {            //약재상세
                    med_hrb_nm : '',    
                    med_prfm : ''
                },
                myApplication : {},         //내처방저장          
                
                currentMenu: 0,            //현재텝                
                
                searchMedicineWord : { //약재 검색어
                    med_hrb_nm : undefined
                },     
                medicinesearchBoxShow: false,       //약재 셀렉트박스 display 여부
                medicineWordlist : [],              //약재 검색 리스트
                medicineDetailData : {},
                myPrescribeRegData : {},                   //개인방제 등록 정보

                searchMyPrescribe : {                  //개인방제사전 검색정보
                    clinic_doctor_id : '',             //한의원 한의사ID
                    prescribe_nm : '',                 //개인방제사전 검색명
                    prescribe_category : '',           //카테고리
                    prescribe_sub_category : '',       //상세카테고리
                    filterIndex : 0,                   //개인사전 필터인덱스
                    pageInfo : {
                      page : 1,
                      pageSize : 10,
                      totPage : 0
                    },
                    myPrescribePageShow : false
                },

                prescrbeCategoryList : [],           // 카테고리 리스트
                prescrbeMySubCategoryList : [],       // 개인방제 상세카테고리 리스트
                prescrbeScretSubCategoryList : [],    // 비방사전 상세카테고리 리스트

                myPrescribelist : [],                //개인방재사전 리스트
                myPrescribeMedicinelist : [],        //개인방재 약재사전 리스트
                myPrescribeInfo : {            //약재상세
                    prescribe_nm : '',    
                    prescribe_source : '',
                    prescribe_medicine : '',
                    prescribe_category : '',
                    prescribe_category_nm : '',
                    item : {}
                },

                searchDictionary : {                //방제사전 검색정보
                    dictionaryCd : '',             //방제사전 검색명
                    dictionaryNm : '',             //방제사전 검색명
                    filterIndex : 0,               //방제사전 필터인덱스    
                    pageInfo : {
                      page : 1,
                      pageSize : 10,
                      totPage : 0
                    },
                    dictionaryPageShow : false
                },

                dictionarylist : [],                //방재사전 리스트
                dictionaryMedicinelist : [],        //방재사전 리스트
                dictionaryInfo : {                  //방제사전 상세
                    prescribe_nm : '',    
                    prescribe_source : '',
                    prescribe_medicine : '',
                    item : {}
                },

                
                searchScretDictionary : {          //비방사전 검색정보
                    scretDictionaryCd : '',              //방제사전 검색명
                    scretDictionaryNm : '',             //방제사전 검색명
                    prescribe_category : '',
                    prescribe_sub_category : '',   //상세카테고리
                    filterIndex : 0,               //방제사전 필터인덱스
                    pageInfo : {
                      page : 1,
                      pageSize : 10,
                      totPage : 0
                    },
                    scretDictionaryPageShow : false
                },

                scretDictionarylist : [],                //비방사전 리스트
                scretDictionaryMedicinelist : [],        //비방사전 리스트
                scretDictionaryInfo : {                  //비방사전 상세
                    prescribe_nm : '',    
                    prescribe_source : '',
                    prescribe_medicine : '',
                    prescribe_category : '',
                    prescribe_category_nm : '',
                    prescribe_sub_category : '',
                    prescribe_sub_category_nm : '',
                    usage_criteria_day : '',
                    usage_criteria_dose : '',
                    usage_criteria_pack : '',
                    usage_criteria_unit : '',
                    item : {},
                    reviewList : []
                },

                prePrescribeInfo : {                  //이전처방 상세
                    prescribe_nm : '',    
                    prescribe_source : '',
                    prescribe_medicine : '',
                    item : {}
                },

                searchPrePrescribe : {             //이전처방 검색정보
                    prescribe_seq : '',            //이전처방 seq 
                    clinic_doctor_id : '',         //한의원 한의사ID
                    prescribe_nm : '',             //이전처방 검색명
                    indications : '',             //이전처방 적응중
                    filterIndex : 0,               //방제사전 필터인덱스
                    startDate : this.getAddMonthDate(-3),                 //이전처방 시작일
                    endDate : this.getCurrentDate(),                   //이전처방 종료일    
                    pageInfo : {
                      page : 1,
                      pageSize : 10,
                      totPage : 0
                    },
                    prePrescribePageShow : false
                },
                prePrescribelist : [],                //이전처방 리스트
                prePrescribeMedicinelist : [],        //이전처방 약재 리스트
                
                viewBox: {},
                viewPouch: {},
                viewWrapper :{},
                pouchImgList : [],                  //파우치 이미지 리스트
                wrapperImgList : [],              // 포장 이미지 리스트
                boxImgList : [],                  //박스 이미지 리스트
                selectPouchImgIdx: 0,
                selectWrapperImgIdx : 0,
                selectBoxImgIdx :0,                    
                boxDisable : false,



                tabIdx: 0,
                tabSelect: null,
                isUserSelect: false,
                
                searchItem: undefined,
                lastStep: false,
                tabMenuNames: {
                    patient: ['환자 정보', '처방 내역', '검색'],                
                    medicine: ['약재', '개인방제', '방제사전', '비방사전','이전처방'],                
                },
                filtered: 0,
                filterKR:['전체','ㄱ','ㄴ','ㄷ','ㄹ','ㅁ','ㅂ','ㅅ','ㅇ','ㅈ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ'],
                price: {
                    jhgPrice : 11000,               //자하거 비용
                    nyAmpulPrice : 20000,           //녹용앰플 비용
                    preparePrice : 160,             //조제비용
                    tangjeonPrice : 12000,          //탕전비용
                    diliveryPrice : 4000,           //배송비용
                    sweetPrice : 1500,              //감미제비용
                    flavoryPrice1 : 2500,            //향기(0.5) 비용
                    flavoryPrice2 : 5000,             //향기(1) 비용
                    pouchPrice: 160,
                    price2: 12000,
                    price3: 5000,
                    price4: 4000,
                },
                isShow: {
                    patient: false,
                    medicine: false,
                    mediSearch: false,
                    totalParice : false
                },
                isDetail: false,
                isSearchDetail : {
                    medicine: false,
                    selfDictionary: false,
                    dictionary: false,
                    beforeReceipt: false,
                    scretDictionary: false,
                },
                tabIndices: {
                    patient: 0,
                    medicine: 0,
                    filterTab: 0,
                    filterTab2: 0,
                    filterTab3: 0,
                },
                gridSelect: {
                    patient: 0,
                    patientPrescribe: 0,
                    medicine: 0,
                    selfDictionary: 0,
                    dictionary: 0,
                    beforeReceipt: 0,
                    scretDictionary : 0
                },
                
                
                rightPatientInfoHead: [
                    { head: '최근처방일' },
                    { head: '구분' },
                    { head: '처방명' },
                    { head: '처방의' },
                    { head: '반영' },
                ],         
                // rightSelfDictionaryHead: [
                //     { head: '처방명' },
                //     { head: '출전' },
                //     { head: '등록자' },
                //     { head: '반영' },
                // ],                      
                userStep: [
                    { step:'탕제 신청', class: 'on' },
                    { step:'복용법', class: undefined },
                    //{ step:'배송 정보', class: undefined },
                    { step:'신청 확인', class: undefined },
                ],   
                

                patientInfoData: [],
                searchData: [],
                

                beforeReceiptData: [],
                selectedBoxList1 : [
                    { path : require('@/assets/img/layout/intro14.jpg'), title : '파우치 1' },
                    { path : require('@/assets/img/layout/intro14.jpg'), title : '파우치 2' },
                    { path : require('@/assets/img/layout/intro14.jpg'), title : '파우치 3' }
                ],

                //복용법관련 데이터
                howTake: [
                    { th : '복용법', require: true, data: format , selected: '', label: '', etcMsg: '', mode : 'upload'},
                    { th : '복용 횟수', require: false, data: count , selected: '', label: '', etcMsg: '' },
                    { th : '복용 시간', require: false, data: time , selected: '', label: '', etcMsg: '' },
                    { th : '복용 온도', require: false , data: temperature, selected: '', label: '', etcMsg: '' },
                    { th : '금할 음식', require: true, data: forbidden , selected: [], label: '', etcMsg: '' , mode: 'select'}
                ],
                
                alertMsg : '',
                initAlertShow : false,
                initInfo : '',
            }

        },
    }
</script>

<style scoped>
.tb_title.blink {
    animation: tb-title-blink 1s ease-in-out infinite;
}
@keyframes tb-title-blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
}
.lay_left--wide {
    min-width: 0;
}
.wrapper-section {
    margin-bottom: 20px;
}
.wrapper-section .tb_title {
    background-color: #F9F7F5;
    border: 1px solid #DACEBD;
    border-bottom: none;
    padding: 10px 16px;
    margin: 0;
    font-size: 1.6rem;
    font-weight: 700;
    color: #333;
}
.img_slide_wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    border: 1px solid #DACEBD;
    padding: 12px 8px;
}
.img_slide_wrap .img_list {
    flex: 1;
    min-width: 0;
    padding: 6px 0;
    justify-content: center;
}
::v-deep .img_slide_wrap .img_list > div.on > img {
    box-shadow: none;
}
::v-deep .img_slide_wrap .img_list > div.on {
    box-shadow: 0 0 0 3px #0c65eb;
    border-radius: 6px;
}
.slide-btn {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border: 2px solid #8b6b4a;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    font-size: 2.2rem;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5c3b1e;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
    transition: background 0.15s, border-color 0.15s;
    padding: 0;
}
.slide-btn:hover:not([disabled]) {
    background: #f5ece3;
    border-color: #5c3b1e;
}
.slide-btn[disabled] {
    opacity: 0.3;
    cursor: default;
    box-shadow: none;
}
.scret_dictionary_list {
    table-layout: fixed;
    width: 100%;
}
.medicine_search_list {
    table-layout: fixed;
    width: 100%;
}
.fixed_col_list {
    table-layout: fixed;
    width: 100%;
}
.scret_dictionary_list td .bdge,
.medicine_search_list td .bdge,
.fixed_col_list td .bdge {
    margin: 0 auto;
}
.tb_title_row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    margin-bottom: 0.8em;
}
.tb_title_row .tb_title {
    margin-bottom: 0;
}
.scret_dictionary_badge {
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 0 16px;
    border-radius: 20px;
    background-color: #1f7bbc;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 700;
    white-space: nowrap;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}
.scret_dictionary_desc {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1f7bbc;
    white-space: nowrap;
}
</style>

